<template>
  <div class="add-task-container">
    <b-row class="ml-0 d-flex flex-wrap w-100">
      <ValidationObserver ref="viewTaskRef" class="col-md-12 col-12 d-flex">
        <b-col xl="9" lg="12" md="12" cols="12" class="main-column">
          <b-breadcrumb
            class="position-relative breadcrumb-container-left pb-2"
          >
            <b-breadcrumb-item v-if="showPABreadcrumb || paBreadcrumb">
              <span
                @click="$router.push({ name: 'ViewPADirectory' })"
                class="text-uppercase font-family-medium"
              >
                Team Directory
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item v-if="showPABreadcrumb || paBreadcrumb">
              <span
                @click="goToPAContactInfo"
                class="text-uppercase font-family-medium"
              >
                {{ getBreadcrumbAssistantName(breadcrumbAssistant)}}
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item v-if="showCustomersBreadcrumb || customerBreadcrumb">
              <span
                @click="navigateToCustomers"
                class="text-uppercase font-family-medium"
              >
                Customers
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item v-if="showCustomersBreadcrumb || customerBreadcrumb">
              <span
                @click="navigateToCustomerDetails"
                class="text-uppercase font-family-medium"
              >
                {{ customerFullName }}
              </span>
            </b-breadcrumb-item>

            <b-breadcrumb-item>
              <span @click="navigateToTasks" class="font-family-medium secondary--text">
                Tasks
              </span>
            </b-breadcrumb-item>

            <b-breadcrumb-item active>
              <span class="font-family-medium">View Task</span>
            </b-breadcrumb-item>
          </b-breadcrumb>
          <div class="heading-wrapper">
            <h1 class="font-lg font-family-medium primary--text content-title">
              View Task
            </h1>
            <div class="d-flex justify-content-end show-timer-container">
              <!-- Countdown timer -->
              <TimerComponent
                v-if="showTimer"
                :canUserOperateTimer="canUserOperateTimer"
                :timeText="formatted"
                :stopAt="stopped"
                :selectedStatus="selectedStatus"
                :timerLoading="timerLoading"
                :selfTask="selfTask"
                @stopTimer="stopTimer"
                @startTimer="restartTimer"
              />
              <!-- Countdown timer -->
            </div>
          </div>
          <b-dropdown-divider
            class="ml-2 tasks-dropdown-divider "
          ></b-dropdown-divider>
          <!-- only will be displayed on smaller screens -->
          <b-container fluid class="outer-container">
            <b-row class="customer-info-box-row">
              <div class="customer-info-box-wrapper">
                <div class="customer-info-box">
                  <template>
                    <div
                      class="avatar-wrapper"
                      @click="navigateToCustomerPreferences"
                      :style="{ cursor: 'pointer' }"
                    >
                      <Avatar :user="taskCustomer" size="6rem" />
                    </div>
                    <div
                      class="customer-info-content"
                      v-if="changeCustomerVisible"
                    >
                      <div class="customer-info-content-name">
                        {{
                          selectedCustomer ? `${selectedCustomer.fullname}` : ""
                        }}
                      </div>
                      <div class="customer-info-content-email">
                        {{ selectedCustomer ? selectedCustomer.email : "" }}
                      </div>
                    </div>
                    <div class="customer-info-content" v-else>
                      <div class="customer-info-content-name">
                        {{
                          taskCustomer
                            ? `${taskCustomer.firstName} ${taskCustomer.lastName}`
                            : ""
                        }}
                      </div>
                      <div class="customer-info-content-email">
                        {{ taskCustomer ? `${taskCustomer.email}` : "" }}
                      </div>
                    </div>
                    <div class="controls-wrapper">
                      <div class="view-preferences-button-wrapper">
                        <b-button @click="openPreferencesSidebar"
                          >View Preferences</b-button
                        >
                      </div>
                      <b-form-group class="" v-if="changeCustomerVisible">
                        <ValidationProvider
                          name="Customer"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <b-form-select
                            @change="getSelectedCustomer"
                            v-model="selectedCustomer"
                            :options="customersList"
                          ></b-form-select>
                          <h6
                            class="font-sm font-family-regular position-relative danger mt-2"
                          >
                            {{ errors[0] }}
                          </h6>
                        </ValidationProvider>
                      </b-form-group>
                    </div>
                  </template>
                </div>
              </div>
            </b-row>
            <!-- skeleton loader -->
            <b-row
              id="skeleton-loader"
              class="d-flex mt-5 w-100 mx-0 contact-info"
              v-if="isLoadingTask"
            >
              <b-col md="8" class="px-0 ml-2">
                <b-form>
                  <b-form-group label="Title" class="tasks-form-group">
                    <b-skeleton type="input"> </b-skeleton>
                  </b-form-group>
                  <b-form-group
                    label="Description"
                    class="tasks-form-group mt-5"
                  >
                    <b-skeleton> </b-skeleton>
                    <b-skeleton> </b-skeleton>
                    <b-skeleton> </b-skeleton>
                    <b-skeleton> </b-skeleton>
                    <b-skeleton> </b-skeleton>
                    <b-skeleton> </b-skeleton>
                    <b-skeleton> </b-skeleton>
                  </b-form-group>
                  <b-form-group label="Category" class="mt-5 tasks-form-group">
                    <b-skeleton type="input"></b-skeleton>
                  </b-form-group>
                  <b-form-group class="tasks-form-group" label="Attachments">
                    <b-row
                      v-for="index in 3"
                      :key="index"
                      align-v="center"
                      align-h="center"
                      class="mb-5 "
                    >
                      <b-col
                        md="4"
                        style="background:#9FCAE2; borderRadius:.2rem"
                        class="pt-3 pb-3 ml-4"
                      >
                        <b-skeleton-img></b-skeleton-img>
                      </b-col>
                      <b-col md="7">
                        <b-row class="mb-4 ">
                          <b-skeleton class="w-80 ml-3"></b-skeleton>
                        </b-row>
                        <b-row>
                          <b-skeleton class="w-80 ml-3"></b-skeleton>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-form-group>
                  <b-form-group label="Checklists" class="tasks-form-group">
                    <div class="checklist-container mt-4">
                      <div
                        class="d-flex flex-direction-row justify-content-between align-content-center flex-wrap mb-5"
                      >
                        <div style="width:70%">
                          <b-skeleton></b-skeleton>
                          <b-skeleton></b-skeleton>
                        </div>
                      </div>
                      <div
                        class="d-flex mt-2 position-relative text-align-center"
                        v-for="index in 3"
                        :key="index"
                      >
                        <div class="w-100">
                          <b-skeleton></b-skeleton>
                        </div>
                      </div>
                    </div>
                  </b-form-group>
                  <b-card
                    class="comment-box-container bg-none border-primary-lighter px-3 pt-2 mt-5 mb-5"
                    no-body
                  >
                    <b-card-body>
                      <h6 class="font-sm primary--text font-family-medium">
                        Activity
                      </h6>
                      <b-row class="d-flex mb-4">
                        <b-col md="1" class="px-0 ml-4 align-self-start">
                          <b-skeleton type="avatar" size="4.4rem"></b-skeleton>
                        </b-col>
                        <b-col md="10" class="mt-2 px-0 ml-3">
                          <b-skeleton type="input"></b-skeleton>
                        </b-col>
                      </b-row>
                      <b-row
                        class="d-flex mb-4"
                        v-for="index in 3"
                        :key="index"
                      >
                        <b-col md="1" class="px-0 ml-4 mt-2 align-self-start">
                          <b-skeleton type="avatar" size="4.4 rem"></b-skeleton>
                        </b-col>
                        <div class="mt-2 px-0 ml-3">
                          <b-card
                            class="mb-3 border-primary-lighter comment-card-body"
                            no-body
                          >
                            <b-card-body class="d-flex pt-3 pb-2">
                              <b-skeleton class="w-100"></b-skeleton>
                            </b-card-body>
                          </b-card>
                        </div>
                      </b-row>
                    </b-card-body>
                  </b-card>
                </b-form>
              </b-col>
              <b-col>
                <b-form-group
                  label="Add Task Properties"
                  class="tasks-form-group"
                >
                  <b-form-group>
                    <b-skeleton type="input"></b-skeleton>
                  </b-form-group>
                  <b-form-group class="mt-5">
                    <b-skeleton type="input"></b-skeleton>
                  </b-form-group>
                  <b-form-group class="mt-5">
                    <b-card
                      no-body
                      class="justify-content-center tasks-attachment-card"
                    >
                      <label
                        class="font-sm d-flex cursor-pointer align-items-center justify-content-between"
                      >
                        <p
                          class="primary--text position-relative d-inline add-attachment-top"
                        >
                          Add attachment
                        </p>
                        <img src="@/assets/icons/form_attachment.svg" alt="" />
                        <!-- 
                          The input file tag was removed as this code is only shown when the UI is disabled,
                          when the file is being loaded.
                         -->
                      </label>
                    </b-card>
                  </b-form-group>
                  <b-form-group class="mb-5 mt-5" label="Checklist">
                    <b-skeleton type="input"></b-skeleton>
                  </b-form-group>
                </b-form-group>
                <b-form-group label="Status *" class="tasks-form-group mt-5">
                  <b-skeleton type="input"></b-skeleton>
                </b-form-group>
                <b-form-group label="Frequency" class="tasks-form-group mt-5">
                  <b-form-group>
                    <b-skeleton type="input"></b-skeleton>
                  </b-form-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-container v-else fluid class="mt-5 inner-container">
              <b-row>
                <b-col id="main-fields" cols="12" md="8">
                  <ValidationProvider
                    name="Title"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <b-form-group
                      label="Title *"
                      class="tasks-form-group"
                    >
                      <b-input-group>
                        <multiselect
                          placeholder="Add title of the task"
                          v-model="taskTitle"
                          label="text"
                          track-by="value"
                          selectLabel=""
                          deselectLabel=""
                          selectedLabel=""
                          hideSelected
                          class="custom-multiselect mb-3"
                          :disabled="formDisabled"
                          @select="saveTaskTitle"
                          :options="taskSuggestions"
                          :taggable="true"
                          @tag="onAddNewTitle"
                          tag-placeholder="Add this as a new Title"
                        >
                          <template
                            slot="singleLabel"
                            slot-scope="{ option }"
                          >
                            {{ ellipsify(option.text, 100) }}
                          </template>
                          <template slot="noResult"
                            >No suggestion found</template
                          >
                        </multiselect>
                      </b-input-group>
                      <h6
                        class="font-sm font-family-regular position-relative danger mt-2"
                      >
                        {{ errors[0] }}
                      </h6>
                      <h6 v-if="savedTitle" class="font-sm saved-text">
                        Saved
                      </h6>
                    </b-form-group>
                  </ValidationProvider>
                  <ValidationObserver>
                    <ValidationProvider name="rte">
                      <b-form-group
                        label="Description"
                        class="tasks-form-group task-desc"
                      >
                        <quill-editor
                          ref="quillEditor"
                          class="quill-custom"
                          :class="formDisabled ? 'grey-editor' : 'quill-editor'"
                          :disabled="formDisabled"
                          v-model="taskDescription"
                          :options="taskEditorOptions"
                          @change="debouncePatchDescription"
                        />
                        <h6 v-if="savedDescription" class="saved-text font-sm">
                          Saved
                        </h6>
                      </b-form-group>
                    </ValidationProvider>
                  </ValidationObserver>
                  <b-form-group
                    label="Category *"
                    class="mt-5 tasks-form-group"
                  >
                    <ValidationProvider
                      name="Categories"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <multiselect
                        placeholder="Select category"
                        @select="getSelectedCategories"
                        @open="removingLastCategory = false"
                        :disabled="
                          formDisabled ||
                            selectedStatus === 'complete'
                        "
                        @remove="removeCategory"
                        :class="[
                          selectedCategories.length === 1
                            ? 'multiselect-grey'
                            : null
                        ]"
                        v-model="selectedCategories"
                        label="text"
                        track-by="id"
                        class="custom-multiselect mb-3 categories-multiselect"
                        :options="categoriesList"
                        :multiple="true"
                      >
                        <template slot="singleLabel" slot-scope="props">
                          <span class="option__desc">
                            <span class="option__title">
                              {{ props.option.title }}
                            </span>
                          </span>
                        </template>
                      </multiselect>
                      <h6
                        class="font-sm font-family-regular position-relative danger mt-2"
                      >
                        {{ errors[0] }}
                      </h6>
                      <h6
                        class="font-sm font-family-regular position-relative danger mt-2"
                        v-if="removingLastCategory"
                      >
                        Atleast one category is required, so please select
                        another to remove this!
                      </h6>
                      <h6 v-if="savedCategories" class="font-sm saved-text">
                        Saved
                      </h6>
                    </ValidationProvider>
                  </b-form-group>
                </b-col>
                <b-col id="task-properties" cols="12" md="4">
                  <b-form-group
                    label="Add Task Properties"
                    class="tasks-form-group mb-4"
                  >
                    <b-form-group>
                      <b-card
                        class="border-primary-lighter tasks-form-card"
                        no-body
                      >
                        <b-card-body :class="{'d-flex': true, 'form-disabled': formDisabled }" style="padding:12px 12px">
                          <b-form-checkbox
                            size="lg"
                            class="checkbox ml-3"
                            style="bottom: 0.4rem"
                            name="check"
                            :disabled="formDisabled"
                            v-model="priority"
                            @change="patchPriority"
                          ></b-form-checkbox>
                          <p
                            class="primary--text position-relative high-priority-text font-size-sm"
                          >
                            High Priority
                          </p>
                        </b-card-body>
                      </b-card>
                      <h6 class="font-sm saved-text" v-if="savedPriority">
                        Saved
                      </h6>
                    </b-form-group>
                    <ValidationProvider
                      name="Due date field"
                      rules="date"
                      v-slot="{ errors }"
                    >
                      <b-form-group class="mt-1">
                        <b-input-group>
                          <b-form-input
                            @change="patchDueDate"
                            id="example-input"
                            :disabled="formDisabled"
                            class="right-tasks-form-input"
                            placeholder="Due date"
                            v-model="dueDate"
                            autocomplete="off"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-form-datepicker
                              button-only
                              right
                              :min="min"
                              :show-decade-nav="true"
                              :disabled="formDisabled"
                              @input="patchDueDate"
                              class="datepicker"
                              locale="en-US"
                              v-model="dueDate"
                              aria-controls="example-input"
                            >
                              <template #button-content="">
                                <img
                                  src="@/assets/icons/date-picker.svg"
                                  alt=""
                                />
                              </template>
                            </b-form-datepicker>
                          </b-input-group-append>
                        </b-input-group>
                        <h6
                          class="font-sm cy-new-intake-date-err mb-0 font-family-regular danger"
                        >
                          {{ errors[0] }}
                        </h6>
                        <h6 class="font-sm saved-text" v-if="savedDueDate">
                          Saved
                        </h6>
                      </b-form-group>
                    </ValidationProvider>
                    <b-form-group class="mt-1">
                      <b-card
                        no-body
                        :class="{'justify-content-center': true, 'tasks-attachment-card': true, 'form-disabled': formDisabled}"
                      >
                        <label
                          class="d-flex cursor-pointer align-items-center justify-content-between"
                        >
                          <p
                            class="primary--text position-relative d-inline add-attachment-top font-size-sm"
                          >
                            Add attachment
                          </p>
                          <img
                            src="@/assets/icons/form_attachment.svg"
                            alt=""
                          />
                          <input
                            type="file"
                            :accept="ACCEPTED_FILE_TYPES"
                            :disabled="
                              formDisabled
                            "
                            ref="fileInput"
                            @change="fileChange"
                            multiple
                            class="d-none"
                          />
                        </label>
                      </b-card>
                      <h6 class="font-sm danger" v-if="sizeExceed">
                        Size cannot be greater than 500MB
                      </h6>
                    </b-form-group>
                    <b-form-group class="mb-1 mt-1">
                      <b-input-group @keypress.enter="createChecklist">
                        <b-form-input
                          autocomplete="off"
                          class="checklist-input"
                          size="lg"
                          v-model="checklistValue"
                          :disabled="
                            formDisabled
                          "
                          placeholder="Add checklist"
                        ></b-form-input>
                        <b-input-group-append
                          class="position-absolute input-icon-container"
                        >
                          <img src="@/assets/icons/checklist.svg" alt />
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-form-group>
                  <b-form-group label="Status *" class="tasks-form-group mb-4">
                    <b-form-select
                      v-model="selectedStatus"
                      :options="statuses"
                      :disabled="formDisabled"
                      @change="getSelectedStatus"
                    ></b-form-select>
                    <h6
                      v-if="selectedStatus === 'null'"
                      class="font-sm font-family-regular position-relative danger mt-2"
                    >
                      This is a required value.
                    </h6>
                    <h6 class="font-sm saved-text" v-if="savedStatus">Saved</h6>
                  </b-form-group>
                  <b-form-group label="Owner" class="tasks-form-group mb-4">
                    <multiselect
                      :value="selectedAssistant"
                      @select="getSelectedAssistant"
                      class="custom-multiselect multiselect-handover"
                      selectLabel=""
                      deselectLabel=""
                      selectedLabel=""
                      :class="[
                        formDisabled
                          ? 'multiselect-disabled'
                          : null
                      ]"
                      :disabled="
                        formDisabled || 
                          selectedStatus === 'complete'
                      "
                      :options="assistantsList"
                      track-by="id"
                      placeholder="Assign to"
                      label="text"
                      data-cy="select-owner"
                    >
                      <template slot="noResult">No PAs found</template>
                      <template slot="noOptions">No PAs found</template>
                    </multiselect>
                  </b-form-group>
                  <b-form-group label="Frequency" class="tasks-form-group mt-1">
                    <b-form-select
                      v-model="selectedFrequency"
                      :options="frequenciesList"
                      :disabled="formDisabled
                      "
                      @change="patchFrequency"
                    ></b-form-select>
                    <h6 class="font-sm saved-text" v-if="savedFrequency">
                      Saved
                    </h6>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row :style="{ flex: 1 }">
                <b-col cols="12" md="8">
                  <b-form>
                    <b-form-group
                      class="tasks-form-group"
                      label="Attachments"
                      v-if="attachments.length"
                    >
                      <AttachmentsComponent
                        :attachments="attachments"
                        @deleteAttachment="deleteAttachment"
                        @deleteImage="onDeleteImage"
                        :isFormEnabled="!formDisabled"
                      />
                    </b-form-group>
                    <b-form-group
                      label="Checklists"
                      class="tasks-form-group"
                      v-if="checklists.length"
                    >
                      <ChecklistComponent
                        :checklists="checklists"
                        :isFormEnabled="!formDisabled"
                        @saveOption="saveChecklistOption"
                        @saveTitle="saveChecklistTitle"
                        @deleteChecklist="deleteChecklist"
                        @deleteOption="removeOption"
                        @updateChecklist="patchChecklist"
                      />
                    </b-form-group>
                    <b-form-group class="tasks-form-group">
                      <b-card 
                        class="bg-none border-primary-lighter comments-container"
                        no-body
                      >
                        <b-card-body>
                          <h6 class="font-sm secondary--text font-family-regular">
                            Activity
                          </h6>
                          <div class="comment">
                              <Avatar
                                :user="assistantUser"
                                size="4.4rem"
                                class="comment-avatar"
                              />
                            <div class="form-input-wrapper">
                              <b-form-textarea
                                type="text"
                                placeholder="Write a comment..."
                                v-model="commentValue"
                                @keypress.enter.prevent="handleAddComment"
                                :disabled="apiLoading"
                                class="add-comment-input-box"
                                size="lg"
                                rows="1"
                                max-rows="50"
                              ></b-form-textarea>
                            </div>
                          </div>
                          <div
                            class="comment"
                            v-for="(comment, index) in comments"
                            :key="comment.id"
                          >
                            <Avatar :user="{fullname: 'H R'}" size="4.4rem" class="comment-avatar" v-if="comment.isSystemGenerated"/>
                            <Avatar :user="comment.author" size="4.4rem" class="comment-avatar" v-else/>
                            <div class="comment-card-wrapper">
                              <b-card
                                class="border-primary-lighter form-input-wrapper"
                                no-body
                              >
                                <b-form-textarea
                                type="text"
                                autofocus
                                @keypress.enter.prevent="handleSaveComment(saveComment, comment, index, $event)"
                                v-if="comment.isEditing"
                                placeholder="Write a comment..."
                                v-model="comment.comment"
                                :disabled="apiLoading"
                                :max-rows="50"
                                :rows="1"
                                class="add-comment-input-box"
                                size="lg"
                                ></b-form-textarea>
                                <b-card-body class="d-flex pt-2 pb-2" v-else @click="onCommentClick(comment)">
                                  <p
                                    class="d-inline primary--text reduce-whitespace-2 position-relative comment-spacing font-size-md"
                                    style="white-space: pre-line;"
                                  >
                                    {{ comment.comment }}
                                  </p>
                                  <div class=comment-delete-icon-wrapper>
                                    <b-icon icon="x" scale="1.5" @click.stop="deleteComment(comment)" v-if="canDeleteComment(comment) && !comment.isEditing"/>
                                  </div>
                                </b-card-body>
                              </b-card>
                              <div class="comment-time secondary--text"> {{ getCommentTimestamp(comment) }} </div>
                            </div>
                          </div>
                        </b-card-body>
                      </b-card>
                    </b-form-group>
                  </b-form>
                </b-col>
              </b-row>
              <b-row v-if="showValidity">
                <div class="ml-4 form-invalid-error-container">
                  <p>There are invalid form fields</p>
                </div>
              </b-row>
              <b-row v-else>
                <div class="form-valid-container" v-if="successMessage">
                  <p>Task updated successfully</p>
                </div>
                <div v-if="errorMessage" class="form-invalid-error-container-2">
                  <p>Some error occured</p>
                </div>
              </b-row>
            </b-container>
          </b-container>
        </b-col>
        <b-col
          id="right-column"
          class="tasks tasks-right-container d-none d-xl-flex d-lg-none d-sm-none d-md-none flex-column"
        >
          <div
            v-if="taskCustomer !== null"
            @click="navigateToCustomerPreferences"
            :class="{
              'info-wrapper': true,
              'first-div': !changeCustomerVisible
            }"
          >
            <div class="avatar-wrapper">
              <Avatar :user="taskCustomer" size="6rem" />
            </div>
            <div
              class="other-wrapper"
              v-if="changeCustomerVisible && selectedCustomer"
            >
              <p class="font-family-regular primary--text" :title="selectedCustomer.fullname">
                {{ ellipsify(selectedCustomer.fullname, 30) }}
              </p>
              <p class="font-family-regular secondary--text" :title="selectedCustomer.email">
                {{ ellipsify(selectedCustomer.email, 30) }}
              </p>
            </div>
            <div class="other-wrapper" v-else>
              <p class="font-family-regular primary--text reduce-line-height" :title="taskCustomer.firstName + ' ' + taskCustomer.lastName">
                {{ ellipsify(taskCustomer.firstName + ' ' + taskCustomer.lastName, 30) }}
              </p>
              <p class="font-family-regular secondary--text" :title="taskCustomer.email">
                {{ ellipsify(taskCustomer.email, 30) }}
              </p>
            </div>
          </div>
          <div class="mx-3" v-if="changeCustomerVisible">
            <ValidationProvider
              name="Customer"
              class="w-100"
              rules="required"
              v-slot="{ errors }"
            >
              <b-form-select
                @change="getSelectedCustomer"
                v-model="selectedCustomer"
                :options="customersList"
              ></b-form-select>
              <h6
                class="font-sm font-family-regular position-relative danger mt-2"
                data-cy="customer-error"
              >
                {{ errors[0] }}
              </h6>
            </ValidationProvider>
          </div>
          <PreferencesComponent
            :notValidCustomer="false"
            :sidebarPreferences="sidebarPreferences"
          />
        </b-col>
      </ValidationObserver>

      <b-modal
        centered
        class="modal-padding"
        hide-footer
        hide-header
        no-close-on-backdrop
        no-close-on-esc
        v-model="showSelectionModal"
        data-cy="task-handover-pop-up"
      >
        <b-container fluid v-if="isAssign">
          <b-button
            @click="showSelectionModal = false"
            class="d-flex position-absolute close-btn"
          >
            <img
              class="close-icon"
              src="@/assets/icons/close_sidebar.svg"
              alt
            />
          </b-button>
          <b-row class="pt-2 pl-4 pr-4 d-flex flex-column">
            <h4
              class="font-md subtext mb-4 mt-3 ml-2"
              v-if="currentTask.handoverRequests.length"
            >
              {{
                currentTask.handoverRequests[0].status === REJECTED &&
                currentTask.handoverRequests[0].assignedTo.id ===
                  assignAssistant.id
                  ? `${assignAssistant.text} has rejected your previous handover request. 
                  Do you want to continue?`
                  : `Do you want to handover the task to the following ${
                      assignAssistant.role && assignAssistant.role.name  === "admin" ? "admin" : "EA"
                    } ?`
              }}
            </h4>
            <h4 class="font-md subtext mb-4 mt-3 ml-2" v-else>
              {{
                `Do you want to handover the task to the following ${
                  assignAssistant.role && assignAssistant.role.name === "admin" ? "admin" : "EA"
                } ?`
              }}
            </h4>
          </b-row>
          <b-row align-v="center">
            <b-col md="8" class="flex-row d-flex mb-4">
              <div>
                <Avatar :user="getModalAvatarUser()" size="7rem" />
              </div>
              <div
                class="d-flex flex-column justify-content-center position-relative ml-4"
              >
                <p class="font-family-medium primary--text mt-2">
                  {{ assignAssistant.text }}
                </p>
                <!-- PA should not be able to see the work hours of other PA -->
                <!-- <p
                  class="secondary--text"
                  v-if="assignAssistant.role.name !== 'admin'"
                >
                  {{ assignAssistant.assistantProfile.workHours }} hours/week
                </p> -->
              </div>
            </b-col>
            <b-button
              @click="handoverPAToClient"
              class="px-5 py-3 btn-pill reduce-whitespace ml-4"
              data-cy="assign-ea-btn"
            >
              Yes, Assign
            </b-button>
          </b-row>

          <b-row
            v-if="
              currentTask.handoverRequests.length &&
                currentTask.handoverRequests[0].status === REJECTED &&
                currentTask.handoverRequests[0].assignedTo.id ===
                  assignAssistant.id
            "
            class="d-flex justify-content-start pl-3 mt-4 mr-2"
          >
            <p class="primary--text ml-3">
              {{ currentTask.handoverRequests[0].reason }}
            </p>
          </b-row>
        </b-container>
      </b-modal>
      <b-modal
        centered
        class="modal-padding"
        hide-footer
        v-model="errorModal.visible"
        hide-header
        no-close-on-backdrop
        no-close-on-esc
      >
        <b-container fluid>
          <b-button
            @click="errorModal.visible = false"
            class="d-flex position-absolute close-btn"
          >
            <img
              class="close-icon"
              src="@/assets/icons/close_sidebar.svg"
              alt
            />
          </b-button>
          <b-row align-v="center" class="px-2 py-2">
            <b-col md="9" class="d-flex mb-2 subtext">
              <h4 class="font-md mt-2">
                {{ errorModal.message }}
              </h4>
            </b-col>
          </b-row>
        </b-container>
      </b-modal>
      <b-modal
        centered
        class="modal-padding"
        hide-footer
        v-model="showAuthError"
        hide-header
        no-close-on-backdrop
        no-close-on-esc
      >
        <b-container fluid>
          <b-button
            @click="reloadPage"
            class="d-flex position-absolute close-btn"
          >
            <img
              class="close-icon"
              src="@/assets/icons/close_sidebar.svg"
              alt
            />
          </b-button>
          <b-row align-v="center" class="px-2 py-2">
            <b-col md="9" class="d-flex mb-2">
              <h4 class="font-md font-family-medium mt-2">
                {{ authMessage }}
              </h4>
            </b-col>
            <b-button
              @click="reloadPage"
              style="top: 0.5rem"
              class="position-relative btn-danger px-5 py-3 btn-pill reduce-whitespace ml-4"
            >
              Close
            </b-button>
          </b-row>
        </b-container>
      </b-modal>
      <b-modal
        centered
        class="modal-padding"
        hide-footer
        hide-header
        no-close-on-backdrop
        no-close-on-esc
        v-model="showSelectionModal"
      >
        <b-container fluid v-if="isAssign">
          <b-button
            @click="showSelectionModal = false"
            class="d-flex position-absolute close-btn"
          >
            <img
              class="close-icon"
              src="@/assets/icons/close_sidebar.svg"
              alt
            />
          </b-button>
          <b-row class="pt-2 pl-4 pr-4 d-flex flex-column">
            <h4
              class="font-md subtext mb-4 mt-3 ml-2"
              v-if="currentTask.handoverRequests.length"
            >
              {{
                currentTask.handoverRequests[0].status === REJECTED &&
                currentTask.handoverRequests[0].assignedTo.id ===
                  assignAssistant.id
                  ? `${assignAssistant.text} has rejected your previous handover request. 
                  Do you want to continue?`
                  : `Do you want to handover the task to the following ${
                      assignAssistant.role && assignAssistant.role.name === "admin" ? "admin" : "EA"
                    } ?`
              }}
            </h4>
            <h4 class="font-md subtext mb-4 mt-3 ml-2" v-else>
              {{
                `Do you want to handover the task to the following ${
                  assignAssistant.role && assignAssistant.role.name === "admin" ? "admin" : "EA"
                } ?`
              }}
            </h4>
          </b-row>
          <b-row align-v="center">
            <b-col md="8" class="flex-row d-flex mb-4">
              <div>
                <Avatar :user="getModalAvatarUser()" size="7rem" />
              </div>
              <div
                class="d-flex flex-column justify-content-center position-relative ml-4"
              >
                <p class="font-family-medium primary--text mt-2">
                  {{ assignAssistant.text }}
                </p>
                <!-- PA should not be able to see the work hours of other PA -->
                <!-- <p
                  class="secondary--text"
                  v-if="assignAssistant.role.name !== 'admin'"
                >
                  {{ assignAssistant.assistantProfile.workHours }} hours/week
                </p> -->
              </div>
            </b-col>
            <b-button
              @click="handoverPAToClient"
              class="px-5 py-3 btn-pill reduce-whitespace ml-4"
            >
              Yes, Assign
            </b-button>
          </b-row>

          <b-row
            v-if="
              currentTask.handoverRequests.length &&
                currentTask.handoverRequests[0].status === REJECTED &&
                currentTask.handoverRequests[0].assignedTo.id ===
                  assignAssistant.id
            "
            class="d-flex justify-content-start pl-3 mt-4 mr-2"
          >
            <p class="primary--text ml-3">
              {{ currentTask.handoverRequests[0].reason }}
            </p>
          </b-row>
        </b-container>
      </b-modal>
      <!-- delete modal -->
      <b-modal
        centered
        class="modal-padding"
        hide-footer
        hide-header
        no-close-on-backdrop
        no-close-on-esc
        v-model="showDeletionModal"
      >
        <b-container fluid class="modal-delete-container">
          <b-button
            @click="showDeletionModal = false"
            class="d-flex position-absolute close-btn"
          >
            <img
              class="close-icon"
              src="@/assets/icons/close_sidebar.svg"
              alt
            />
          </b-button>
          <b-row align-v="center">
            <b-col md="12" class="flex-row d-flex p-0">
              <div
                class="d-flex flex-column justify-content-center position-relative m-0"
              >
                <p
                  class="font-family-medium primary--text mt-2 delete-popup-title"
                >
                  Are you sure?
                </p>
                <p
                  class="font-family-regular secondary--text mt-1 font-size-md"
                >
                  Do you want to delete this task?
                </p>
              </div>
            </b-col>
            <b-button
              class="btn-danger btn-pill px-5 py-3 mt-4 mb-2"
              @click.prevent="deleteTask"
              v-if="!success"
            >
              <b-spinner
                v-if="pageLoading2"
                style="width: 14px; height: 14px"
                variant="light"
                label="Spinning"
              ></b-spinner>
              {{ `${!pageLoading2 ? "Delete" : "    "}` }}
            </b-button>
          </b-row>
        </b-container>
      </b-modal>
      <!-- Task Archive modal -->
      <b-modal
        centered
        class="modal-padding"
        hide-footer
        hide-header
        no-close-on-backdrop
        no-close-on-esc
        v-model="showArchiveModal"
      >
        <b-container fluid class="modal-archive-container">
          <b-button
            @click="showArchiveModal = false"
            class="d-flex position-absolute close-btn"
          >
            <img
              class="close-icon"
              src="@/assets/icons/close_sidebar.svg"
              alt
            />
          </b-button>
          <b-row align-v="center">
            <b-col md="12" class="flex-row d-flex p-0">
              <div
                class="d-flex flex-column justify-content-center position-relative m-0"
              >
                <p
                  class="font-family-medium primary--text mt-2 archive-popup-title"
                >
                  Are you sure?
                </p>
                <p
                  class="font-family-regular secondary--text mt-1 font-size-md"
                >
                  Do you want to archive this task?
                </p>
              </div>
            </b-col>
            <b-button
              class="btn-danger btn-pill px-5 py-3 mt-4 mb-2"
              @click.prevent="archiveTask"
              v-if="!success"
            >
              <b-spinner
                v-if="pageLoading_archive"
                style="width: 14px; height: 14px"
                variant="light"
                label="Spinning"
              ></b-spinner>
              {{ `${!pageLoading_archive ? "Archive" : "    "}` }}
            </b-button>
          </b-row>
        </b-container>
      </b-modal>
    </b-row>
    <b-row class="delete-button-row">
      <div>
        <b-button
          class="btn-delete btn-pill px-5 py-3 mt-2 mb-5 font-size-md"
          @click.prevent="showDeletionModal = true"
          v-if="!success && (isAdmin() || selectedStatus !== 'complete')"
          :disabled="!deleteEnabled"
        >
          <b-spinner
            v-if="pageLoading2"
            style="width: 14px; height: 14px"
            variant="danger"
            label="Spinning"
          ></b-spinner>
          {{ `${!pageLoading2 ? "Delete" : "    "}` }}
        </b-button>
        <b-button
          class="btn-primary btn-pill px-5 py-3 mt-2 mb-5 font-size-md"
          @click.prevent="showArchiveModal = true"
          v-if="!success || selectedStatus !== 'complete'"
          :disabled="!deleteEnabled"
        >
          <b-spinner
            v-if="pageLoading_archive"
            style="width: 14px; height: 14px"
            variant="primary"
            label="Spinning"
          ></b-spinner>
          {{ `${!pageLoading_archive ? "Archive" : "    "}` }}
        </b-button>
      </div>
      <div>
      </div>
    </b-row>
    <b-toast
      id="save-indicator"
      solid
      ref="saveIndicator"
      :no-close-button="true"
      :no-auto-hide="true"
      :no-fade="true"
      toaster="b-toaster-top-center"
      :visible="isSaveIndicatorVisible"
    >
      <div id="loading-icon-wrapper" v-show="indicatorsVisible.saving">
        <img src="@/assets/icons/save-loading.svg" />
      </div>
      <div id="saved-icon-wrapper" v-show="indicatorsVisible.saved">
        <img src="@/assets/icons/save-tick.png" />
      </div>
      <div id="save-indicator-text">
        {{ indicatorsVisible.saving ? "Saving..." : "Saved" }}
      </div>
    </b-toast>
    <b-toast
      id="save-error-indicator"
      solid
      :no-close-button="true"
      :no-auto-hide="true"
      :no-fade="true"
      toaster="b-toaster-top-center"
      v-model="indicatorsVisible.error"
    >
      <div id="error-icon-wrapper">
        <img src="@/assets/icons/save-error.svg" />
      </div>
      <div id="save-indicator-text-error">
        Error! Something went wrong
      </div>
      <div id="save-indicator-close-icon">
        <img
          src="@/assets/icons/close_sidebar.svg"
          @click="closeErrorIndicator"
        />
      </div>
    </b-toast>
    <TaskSidebarComponent
      :visible="preferencesSidebar.visible"
      @closeSidebar="closePreferencesSidebar"
      :sidebarPreferences="sidebarPreferences"
      :selectedCustomer="selectedCustomer"
    />
    <b-modal
      id="delete-checklist-modal"
      v-model="deleteModal.visible"
      body-class="delete-checklist-modal-body"
      hide-header
      hide-footer
      centered
    >
      <h1 class="font-lg">Are you sure?</h1>
      <h3 class="font-lg">Do you want to delete the checklist?</h3>
      <div class="buttons-row">
        <div class="buttons-wrapper">
          <div class="button-wrapper">
            <b-button class="cancel-button" @click="deleteModal.visible = false"
              >Cancel</b-button
            >
          </div>
          <div class="button-wrapper">
            <b-button
              class="delete-button"
              @click="deleteChecklist(deleteModal.checklistIndex)"
              :disabled="apiLoading"
              >Confirm Delete</b-button
            >
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      body-class="delete-comment-modal-body"
      hide-header
      hide-footer
      size="md"
      visible
      centered
      v-model="deleteCommentModal.visible"
      no-close-on-esc
      no-close-on-backdrop
    >
      <b-button @click="deleteCommentModal.visible = false" class="close-button">
        <img
          class="close-icon"
          src="@/assets/icons/close_sidebar.svg"
          alt
          @click="deleteCommentModal.visible = false"
        />
      </b-button>

      <div class="title-row primary-dark font-family-medium">
        Are you sure?
      </div>
      <div class="desc-row">
        Do you want to delete this comment?
      </div>
      <div class="button-row">
        <div id="submit-button-wrapper">
          <b-button class="cancel-button btn-pill" @click="deleteCommentModal.visible = false">
              Cancel
          </b-button>
          <b-button class="btn-delete btn-pill" @click="_deleteComment" :disabled="deleteCommentModal.loading">
            <b-spinner v-if="deleteCommentModal.loading"/>
            <template v-else>
              Confirm Delete
            </template>
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import { editorOptions, ACCEPTED_FILE_TYPES } from '@/utils/constants'
// import TinyEditor from "@tinymce/tinymce-vue";
import { ACCEPTED, REJECTED, NOACTION } from "@/utils/constants/index.js";
import Multiselect from "vue-multiselect";
import _ from "lodash";
import TimerComponent from "@/components/timer/TimerComponent";
import AttachmentsComponent from "@/components/attachments/AttachmentsComponent";
import ChecklistComponent from "@/components/checklists/ChecklistComponent";
import TaskSidebarComponent from "@/components/taskpreferences/TaskSidebarComponent";
import PreferencesComponent from "@/components/taskpreferences/PreferencesComponent";
import Avatar from "@/components/avatar/Avatar.vue";
import {
  updateChecklistItemPositionsAsync,
  onChecklistItemDrop,
  onDragStart,
  onDragEnd
} from "@/utils/checklistDndUtils";
import { getInitials, isImage, ellipsify, isAdmin } from "@/utils/utils";
import useUndoRedo from "../../utils/undo-redo-utils";
import {
  ValidationProvider,
  ValidationObserver,
  extend
} from "vee-validate/dist/vee-validate.full";
extend("required", {
  message: () => "This is a required field"
});
let dateMessage;
extend("date", {
  message: () => dateMessage,
  validate: value => {
    let mustContainTheseChars = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
    let containsRequiredChars = mustContainTheseChars.test(value);
    if (containsRequiredChars) {
      if (moment(value).isSameOrAfter(moment({ hour: 0 }))) {
        return true;
      } else {
        dateMessage = "Date cannot be from past";
        return false;
      }
    } else {
      dateMessage = "YYYY-MM-DD format required";
      return false;
    }
  }
});
import moment from "moment";
import {
  deleteTaskCategoryAttachment,
  deleteTaskCategoryChecklist,
  deleteTaskCategoryChecklistOptions,
  getCategories,
  getCategory,
  patchTask,
  patchTaskBoard,
  patchTracker,
  postAttachments,
  postTracker,
  getTaskSuggestionList
} from "@/apis/common";
import {
  deleteTask,
  getActiveCustomersMinimal,
  getCategoryPreferences,
  getTask,
  patchTaskChecklist,
  postTaskAttachments,
  postTaskChecklist,
  postTaskComments,
  getComments,
  deleteComment,
  patchComment,
  getAttachments,
  getChecklists,
  postTaskChecklistOption,
  archiveTask
} from "@/apis/customers";
import { mapState } from "vuex";
import { getProfile, getTaskStatus } from "@/utils/utils";
import {
  getAdmins,
  getAssistantsList,
  handOverTask,
  updateHandOverTask
} from "@/apis/assistants";
import Worker from "worker-loader!@/workers/TimerWorker.js";

function optionsSortFn(optionA, optionB) {
  return optionA.position - optionB.position;
}
export default {
  name: "ViewTask",
  components: {
    ValidationObserver,
    Multiselect,
    ValidationProvider,
    TimerComponent,
    quillEditor,
    TaskSidebarComponent,
    PreferencesComponent,
    Avatar,
    AttachmentsComponent,
    ChecklistComponent
  },
  data() {
    return {
      ACCEPTED_FILE_TYPES,
      ACCEPTED,
      REJECTED,
      NOACTION,
      breadcrumbAssistant: null,
      errorModal: {
        visible: false,
        message: "File is empty. Cannot upload"
      },
      deleteCommentModal: {
        visible: false,
        loading: false,
        commentId: null
      },
      deleteModal: {
        visible: false,
        checklistIndex: null
      },
      sizeExceed: false,
      timerLoading: false,
      apiLoading: false,
      indicatorsVisible: {
        saving: false,
        saved: false,
        error: false
      },
      taskEditorOptions: {},
      min: moment().format("YYYY-MM-DD"),
      savedTitle: false,
      savedDescription: false,
      savedCategories: false,
      savedPriority: false,
      savedDueDate: false,
      savedStatus: false,
      savedHandover: false,
      savedFrequency: false,
      assistantsList: [],
      showSelectionModal: false,
      showDeletionModal: false,
      showArchiveModal: false,
      isAssign: false,
      isUnassign: false,
      assignAssistant: null,
      selectedAssistant: "",
      adminHandoverTask: false,
      selfTask: true,
      priority: false,
      carouselData: [],
      assistantInitials: "",
      assistantUser: {},
      assistantFullName: "",
      startedAt: "",
      prevRouteParams: {},
      selectedCustomer: null,
      taskCustomer: null,
      completionDate: "",
      dueDate: "",
      customersList: [],
      slide: 0,
      slide2: 0,
      formatted: "00:00:00",
      taskId: "",
      showTimer: false,
      sliding: null,
      sliding2: null,
      selectedCategories: [],
      selectedStatus: null,
      customerUser: {},
      avatarName: "",
      customerID: "",
      duration: "",
      stopped: null,
      assistantId: "",
      selectedFrequency: "none",
      preferences: [],
      slideArray: [],
      attachments: [],
      removedAttachments: [],
      removedChecklists: [],
      removedOptions: [],
      membership: "",
      checklistValue: "",
      checklists: [],
      taskDescription: "",
      undoRedoPressed: false,
      timer: false,
      taskTitle: "",
      customerEmail: "",
      customerAvatar: null,
      showValidity: false,
      pageLoading: false,
      pageLoading2: false,
      pageLoading_archive: false,
      success: false,
      trackerID: "",
      errorMessage: false,
      successMessage: false,
      totalApiCalls: [],
      passedApiCalls: [],
      preferencesSidebar: {
        visible: false
      },
      commentValue: "",
      showAuthError: false,
      authMessage: "",
      statusID: null,
      currentTask: "",
      createdAt: "",
      isLoadingTask: true,
      frequenciesList: [
        {
          value: "none",
          text: "None"
        },
        {
          value: "daily",
          text: "Daily"
        },
        {
          value: "weekly",
          text: "Weekly"
        },
        {
          value: "monthly",
          text: "Monthly"
        },
        {
          value: "yearly",
          text: "Yearly"
        }
      ],
      taskStatuses: [],
      statuses: [
        {
          value: "null",
          text: "Select Status",
          disabled: true,
        },
        {
          value: "complete",
          text: "Complete"
        },
        {
          value: "daily",
          text: "Daily"
        },
        {
          value: "in-progress",
          text: "In Progress"
        },
        {
          value: "later",
          text: "Later"
        },
        {
          value: "today",
          text: "Today"
        }
      ],
      categoriesList: [],
      comments: [],
      showPABreadcrumb: null,
      showCustomersBreadcrumb: null,
      customerFullName: "",
      customerInitials: "",
      taskSuggestions: [],
      removingLastCategory: false,
      taskHistoryPrefix: "taskDescHistory-",
      maxUndoSteps: 15
    };
  },
  computed: {
    ...mapState("authModule", [
      "role",
      "profileUserId",
      "navAvatar",
      "firstName",
      "lastName"
    ]),
    showControls() {
      return this.carouselData.length > 1 ? true : false;
    },
    quillInstance() {
      return this.$refs.quillEditor.quill;
    },
    canUserOperateTimer() {
      if (isAdmin()) {
        return true
      }
      let loggedInUserId = this.$store.state.authModule.profileUserId
      return this.selectedAssistant.id === loggedInUserId
    },
    formDisabled() {
      const isFormDisabled = (
        this.completionDate !== "" ||
        this.stopped !== null ||
        this.startedAt === null ||
        !this.selfTask ||
        this.selectedStatus === "complete" ||
        this.apiLoading
      );
      let loggedInUserId = this.$store.state.authModule.profileUserId

      if (isAdmin()) {
        return isFormDisabled
      } else {
        return isFormDisabled || this.selectedAssistant.id !== loggedInUserId
      }
    },
    deleteEnabled() {
      let loggedInUserId = this.$store.state.authModule.profileUserId
      
      if (isAdmin()) {
        return true
      } else {
        return this.selectedAssistant.id === loggedInUserId
      }
    },
    disableChecklistOptionAdd() {
      return this.checklists.some(checklist => {
        return checklist.showNewOptionBox;
      });
    },
    sidebarPreferences() {
      return this.preferences
        .map(preference => {
          return {
            id: preference?.categories?.category?.id,
            title: preference.categories.category.title,
            descriptions: preference.categories.preferences.map(
              pref => pref.detail
            )
          };
        })
        .filter(preference => {
          // * don't show preferences which have no description content
          return preference.descriptions.length > 0;
        });
    },
    isSaveIndicatorVisible() {
      let ret = this.indicatorsVisible.saving || this.indicatorsVisible.saved;
      return ret;
    },
    changeCustomerVisible() {
      if (!this.currentTask) {
        return false;
      }
      let handoverExists = this.currentTask.handoverRequests.length > 0;
      let isOwnTask = this.currentTask.assignedTo.id === this.profileUserId;
      let handoverAccepted =
        handoverExists &&
        this.currentTask.handoverRequests[0].assignedTo.id ===
          this.currentTask.assignedTo.id &&
        isOwnTask &&
        this.currentTask.handoverRequests[0].status === ACCEPTED;
      if (!handoverExists && isOwnTask) {
        return false;
      } else if (handoverExists && handoverAccepted) {
        return false;
      } else {
        return false;
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name === "PADetails") {
        vm.showPABreadcrumb = true;
        vm.prevRouteParams = from.params;
      } else if (from.name === "CustomerDetails") {
        vm.showCustomersBreadcrumb = true;
        vm.prevRouteParams = from.params;
      }
    });
  },
  mounted() {
    this.getEditorOptions();
  },
  created() {
     // * if the task is viewed in pop up mode, then the task-id will be a parameter
    this.taskId = this.$route.params.id || this.modalTaskId

    this.initialiseUndoRedo(this.taskId)

    const BUFFER = 500;
    this.customersList.unshift({
      value: null,
      text: "Select Customer"
    });
    this.showSaveIndicator = _.debounce(this.showSaveIndicator, BUFFER);
    this.showSaveIndicatorSaved = _.debounce(
      this.showSaveIndicatorSaved,
      BUFFER
    );
    this.showSaveIndicatorError = _.debounce(
      this.showSaveIndicatorError,
      BUFFER
    );
    
    this.getTask();
    if (this.$route.name === "ViewCustomerTask") {
      this.showCustomersBreadcrumb = true;
    } else if (this.$route.name === "ViewPATask") {
      this.showPABreadcrumb = true;
    } else if (this.$route.name === "ViewPACustomerTask") {
      this.showCustomersBreadcrumb = true;
      this.showPABreadcrumb = true;
    }

    this.loadChecklists();
    this.loadAttachments();
    this.getTaskNameSuggestion();
  },
  beforeDestroy() {
    if (window.Worker) {
      if (this.worker) {
        this.worker.terminate()
        this.timer = false
      }
    } else {
      clearInterval(this.timer)
    }
  },
  props: {
    paBreadcrumb: {
      type: Boolean,
      default: false
    },
    customerBreadcrumb: {
      type: Boolean,
      default: false
    },
    modalTaskId: {
      type: String,
      default: ''
    },
    isPopupMode: {
      type: Boolean,
      default: false
    },
    queueName: String
  },
  methods: {
    isImage,
    ellipsify,
    isAdmin,
    trackUndoRedo(action) {
      this.$gtag.event(`Undo Redo - ${action}`, {
        event_category: "feature",
        event_label: `${action} called`
      });
    },
    getBreadcrumbAssistantName(breadcrumbAssistant) {
      if (!breadcrumbAssistant) {
        return ''
      }
      return breadcrumbAssistant.user ? `${breadcrumbAssistant.user.firstName} ${breadcrumbAssistant.user.lastName}` : breadcrumbAssistant.fullname
    },
    getAuxillaryData() {
      getAssistantsList({ type: 'filter_with_avatar' })
        .then(res => {
          let assistants = res.data.results .filter(el => {
              if (el.id !== this.profileUserId) {
                return el;
              }
            })
            .map(item => {
              item.text = item.fullname
              return item;
            });
          this.assistantsList = [
            ...this.assistantsList,
            ...assistants
          ]
          this.breadcrumbAssistant = res.data.results.find(assistant => assistant.id === this.$route.params.uuid)
        })
        .catch(err => console.log(err));
      getAdmins()
        .then(res => {
          let admins = res.data.results.filter(el => el.id !== this.profileUserId)
          .map(item => {
            item.text = `${item.user.firstName} ${item.user.lastName}`;
            return item;
          });
          this.assistantsList = [
            ...this.assistantsList,
            ...admins
          ]
        })
        .catch(err => console.log(err));

      getCategories().then(res => {
        this.categoriesList = [...res.data.results].map(item => {
          item.text = item.title;
          return item;
        })
        .sort((a, b) => a.text.localeCompare(b.text));
      })
      .catch(err => {
        console.log(err);
      });
    },
    getTask() {
      getProfile().then(async res => {
        let assistantFullname = `${res.data.firstName} ${res.data.lastName}`;
        this.assistantUser = res.data;
        this.assistantInitials = assistantFullname.match(/\b(\w)/g).join("");
        
        getTask(this.taskId).then(res => {
          this.taskCustomer = res.data.createdFor;
          const customersLoaded = getActiveCustomersMinimal(this.profileUserId).then(res => {
            this.customersList = res.data.results.map(item => {
              item.text = `${item.fullname}`;
              item.value = item;
              return item;
            });
            
            this.customersList.unshift({
              value: null,
              text: "Select Customer"
            });
          })
          .catch(err => {
            console.log(err);
          });
          customersLoaded.then(() => {
            this.selectedCustomer = this.customersList.find(customer => customer.profileId === this.taskCustomer.id)
          })
          this.currentTask = res.data;
          this.frequenciesList.map(item => {
            if (
              res.data.availableFrequencyChoices.includes(item.value) ||
              item.value === res.data.frequency
            ) {
              item.disabled = false;
            } else {
              item.disabled = true;
            }
          });
          let handoverExists = res.data.handoverRequests.length > 0;
          if (handoverExists) {
            let handoverRequest = res.data.handoverRequests[0];
            let isTaskOwner =
              res.data.assignedTo.id === this.profileUserId &&
              handoverRequest.assignedTo.id === this.profileUserId &&
              handoverRequest.status === ACCEPTED;
            let isUserHandoverTaskOwner =
              handoverRequest.assignedTo.id === this.profileUserId &&
              handoverRequest.status === ACCEPTED;
            let isHandoverRejected =
              handoverRequest.requestedBy.id === this.profileUserId &&
              handoverRequest.status === REJECTED;
            let isAdmin = this.isAdmin();
            this.selfTask =
              isTaskOwner || isUserHandoverTaskOwner || isHandoverRejected || isAdmin;
            if (
              handoverRequest.status === ACCEPTED ||
              handoverRequest.status === NOACTION
            ) {
              this.selectedAssistant = handoverRequest.assignedTo;
              this.selectedAssistant.text = `${handoverRequest.assignedTo.firstName} ${handoverRequest.assignedTo.lastName}`;
            } else {
              this.selectedAssistant = res.data.assignedTo;
              this.selectedAssistant.text = `${res.data.assignedTo.firstName} ${res.data.assignedTo.lastName}`;
            }
          } else {
            this.selectedAssistant = res.data.assignedTo;
            this.selectedAssistant.text = `${res.data.assignedTo.firstName} ${res.data.assignedTo.lastName}`;
          }
          this.completionDate = res.data.completedDate
            ? res.data.completedDate
            : "";

          
          this.priority = res.data.priority === "high" ? true : false;
          this.startedAt = res.data.lastTracker.startAt
            ? moment(res.data.lastTracker.startAt)
            : null;
          this.dueDate = res.data.dueDate;
          this.selectedFrequency = res.data.frequency;
          this.stopped =
            res.data.lastTracker.stopAt === null
              ? null
              : moment(res.data.lastTracker.stopAt);
          this.trackerID = res.data.lastTracker.id;
          if (
            res.data.lastTracker.stopAt !== null ||
            res.data.lastTracker.startAt === null
          ) {
            this.duration = res.data.trackersLog.timeSpent;
            let dura = moment.duration(this.duration, "seconds");
            let Seconds = dura._data.seconds;
            if (Seconds < 10) {
              Seconds = `0${Seconds}`;
            }
            let Minutes = dura._data.minutes;
            if (Minutes < 10) {
              Minutes = `0${Minutes}`;
            }
            let Hours = dura._data.hours + dura._data.days * 24;
            if (Hours < 10) {
              Hours = `0${Hours}`;
            }
            this.formatted = `${Hours}:${Minutes}:${Seconds}`;
          } else {
            this.duration = moment()
              .utc()
              .diff(res.data.lastTracker.startAt, "seconds");
            (this.duration += res.data.trackersLog.timeSpent), "seconds";
            this.startTimer();
          }
          let { firstName, lastName } = res.data.assignedTo;
          this. assistantFullName= `${firstName} ${lastName}`;
          this.selectedCategories = [...res.data.categories].map(item => {
            item.text = item.title;
            return item;
          });
          this.customerID = res.data.createdFor.id;

            this.taskTitle = { value: res.data.title, text: res.data.title };
          this.taskDescription = res.data.description;
          let taskStatus = res.data.status.id;
          getTaskStatus().then(res => {
            this.taskStatuses = [...res.data.results].map(item => {
              item.text = item.title;
              item.value = item;
              return item;
            });
            this.taskStatuses.map(el => {
              if (el.id === taskStatus) {
                this.selectedStatus = el.slug;
              }
            });
            this.showTimer = true;
          });
          this.membership = res.data.createdFor.membership;
          this.assistantId = res.data.assignedTo.id;
          this.customerUser = res.data.createdFor;
          this.customerFullName = `${this.customerUser.firstName} ${this.customerUser.lastName}`;
          this.customerInitials = this.customerFullName
            .match(/\b(\w)/g)
            .join("");
          this.customerEmail = res.data.createdFor.email;
          this.customerAvatar = res.data.createdFor.avatarThumbnail;
          this.isLoadingTask = false;
          // * loading the preferences and comments last because the have the lowest priority
          this.loadPreferences()
          this.loadComments()
          })
          .catch(err => {
            if (err.message.includes("code 403")) {
              this.$router.push({
                name: "403",
                params: {
                  message: "You don't have permission to access this task",
                  code: "403"
                }
              });
            } else {
              this.$router.push({
                name: "404",
                params: {
                  message: "This task does not exist",
                  code: "404"
                }
              });
            }
          });
      });
      this.getAuxillaryData();
    },
    loadPreferences() {
      let categoryIds = this.selectedCategories.map(category => category.id).join(",");

      getCategoryPreferences(this.taskCustomer.id, categoryIds).then(res => {
        res.data.results.forEach(() => {
          this.slideArray.push(0);
        });
        this.preferences = [...res.data.results];
      });
    },
    async loadComments() {
      try {
        let params = {
          ordering: "-created"
        };
        let res = await getComments(this.taskId, params)
        let comments = res.data.results;
        this.comments = comments
          .map(item => {
            let fullName = `${item.author.firstNdame} ${item.author.lastName}`;
            let comment = item.comment;
            let updatedComment = "";
            if (comment.includes("corrected timer entry")) {
              let startTimeStartIndex = comment.search("start = ") + 8;
              let startTimeEndIndex = startTimeStartIndex + 16;
              let startTimeSubstr = comment.substring(
                startTimeStartIndex,
                startTimeEndIndex
              );
              let startTime = this.getLocalTime(startTimeSubstr);

              let stopTimeStartIndex = comment.search("stop = ") + 7;
              let stopTimeEndIndex = stopTimeStartIndex + 16;
              let stopTimeSubstr = comment.substring(
                stopTimeStartIndex,
                stopTimeEndIndex
              );
              let stopTime = this.getLocalTime(stopTimeSubstr);

              let textBeforeStartTime = comment.substring(
                0,
                startTimeStartIndex
              );
              let textAfterStartTime = comment.substring(
                startTimeEndIndex,
                stopTimeStartIndex
              );
              let textAfterStopTime = comment.substring(stopTimeEndIndex);

              updatedComment =
                textBeforeStartTime +
                startTime +
                textAfterStartTime +
                stopTime +
                textAfterStopTime;
            } else {
              updatedComment = comment;
            }
            return {
              fullName,
              avatarText: fullName.match(/\b(\w)/g).join(""),
              isEditing: false,
              ...item,
              comment: updatedComment
            };
          })
          .filter(
            comment =>
              !(
                comment.comment.endsWith("started the timer.") ||
                comment.comment.endsWith("stopped the timer.")
              )
          );
      } catch (e) {
        console.log(e);
      }
    },
    getLocalTime(input) {
      return moment
        .utc(input, "YYYY:MM:DD HH:mm", true)
        .local()
        .format("YYYY:MM:DD hh:mm A");
    },
    async loadAttachments() {
      try {
        let res = await getAttachments(this.taskId)
        this.attachments = res.data.results
      } catch(e) {
        console.log(e)
      }
    },
    async loadChecklists() {
      try {
        let res = await getChecklists(this.taskId) 
        let sortedChecklists = res?.data?.results.map(checklist =>
          this.sortChecklistByPosition(checklist)
        );
        this.checklists = sortedChecklists;
      } catch(e) {
        console.log(e)
      }
    },
    sortChecklistByPosition(checklist) {
      let sortedChecklist = _.cloneDeep(checklist);
      sortedChecklist.options = [];
      checklist?.options.forEach(option => {
        sortedChecklist.options[option.position] = option;
      });
      sortedChecklist.options = sortedChecklist.options.filter(
        value => value !== undefined
      );
      return sortedChecklist;
    },
    getSelectedCustomer(element) {
      if (element.id) {
        let customer = element;
        this.customerInitials = getInitials(customer.fullname);
        this.customerEmail = customer.email;
        this.customerAvatar = customer.avatarThumbnail;
        let payload = this.selectedCategories.map(category => category.id);
        let categoryIDs = payload.join(",");
        this.customerID = customer.profileId;
        getCategoryPreferences(this.customerID, categoryIDs).then(res => {
          res.data.results.forEach(() => {
            this.slideArray.push(0);
          });
          this.preferences = [...res.data.results];
        });
        this.closeErrorIndicator();
        this.showSaveIndicator();
        const data = {
          createdFor: this.customerID
        };
        patchTask(this.taskId, data)
          .then(() => {
            this.taskCustomer = customer;
            this.showSaveIndicatorSaved();
          })
          .catch(err => {
            console.log(err);
            this.showSaveIndicatorError();
            this.showAuthError = true;
            this.authMessage = err.response.data.detail;
          });
      }
    },
    getEditorOptions() {
      let tempOptions = _.cloneDeep(editorOptions);
      tempOptions.modules.toolbar.container.push(["myUndo", "myRedo"]);
      tempOptions.modules.toolbar.handlers = {
        myUndo: this.onUndoTaskDescription,
        myRedo: this.onRedoTaskDescription
      };
      this.taskEditorOptions =  {...tempOptions };
    },
    debouncePatchDescription: _.debounce(function() {
      this.saveTaskDescription();
    }, 1000),
    addUndoRedoStep(inputData) {
      const { setDataAndPointer, updateUndoRedoData } = useUndoRedo();

      const { data, pointer } = setDataAndPointer(
        this.maxUndoSteps, this.taskId, this.taskHistoryPrefix
      );
      const lastEntry = data[data.length - 1]

      const lastEntryIsIdentical = lastEntry?.content === inputData
      if (lastEntryIsIdentical) { return }

      data.push({ content: inputData })
      updateUndoRedoData(data, pointer, this.taskId, this.taskHistoryPrefix)
    },

    onUndoTaskDescription() {
      this.undoRedoHandler("undo");
    },
    onRedoTaskDescription() {
      this.undoRedoHandler("redo");
    },
    undoRedoHandler(action) {
      this.trackUndoRedo(action);
      const { onUndoRedoHander } = useUndoRedo();
      const { noPointer, undoRedoPressed, description } = onUndoRedoHander(
        this.taskId,
        this.taskHistoryPrefix,
        action
      );

      if (noPointer) { return false }

      const lastEntryIsIdentical = description === this.taskDescription
      if (lastEntryIsIdentical) {
        // * If they are the same we skip the update to avoid unnecessary network calls.
        // * We also avoid setting `this.undoRedoPressed` as this property is only reset
        // * in the `saveTaskDescription` method, called by the `debouncePatchDescription` method.
        return
      }

      this.undoRedoPressed = undoRedoPressed
      this.taskDescription = description

      this.debouncePatchDescription()
    },

    initialiseUndoRedo(itemId) {
      const { clearAllPreviousHistory } = useUndoRedo()
      clearAllPreviousHistory(itemId)

      // * Note that here we are watching for the global `this.isLoadingTask`,
      // * which caters for all the data for the item.
      // * The patterns is different in `ViewEditPreference.vue`.
      const unregisterTheWatcher = this.$watch('isLoadingTask', (isLoading) => {
        if (!isLoading && this.taskDescription) {
        // * initialise the undo/redo history
        this.addUndoRedoStep(this.taskDescription)
          unregisterTheWatcher()
        }
      })
    },

    onAddNewTitle(newTag) {
      const tag = {
        value: newTag,
        text: newTag
      };
      this.saveTaskTitle(tag);
    },
    async saveTaskTitle(selectedTitle) {
      const valid = await this.$refs?.viewTaskRef?.validate();
      if (valid) {
        this.closeErrorIndicator();
        this.showValidity = false;
        this.showSaveIndicator();
        this.taskTitle = selectedTitle;
        const data = {
          title: selectedTitle.value
        };
        patchTask(this.taskId, data)
          .then(() => {
            this.showSaveIndicatorSaved();

          })
          .catch(err => {
            this.showSaveIndicatorError();
            console.log(err);
            this.showAuthError = true;
            this.authMessage = err.response.data.detail;
          });
      } else {
        this.showValidity = true;
      }
    },
    async saveTaskDescription() {
      const valid = await this.$refs?.viewTaskRef?.validate();
      if (valid) {
        this.closeErrorIndicator();
        this.showSaveIndicator();
        this.showValidity = false;
        const data = {
          description: this.taskDescription
        };
        patchTask(this.taskId, data)
          .then(() => {
            this.showSaveIndicatorSaved();
            this.undoRedoPressed
              ? (this.undoRedoPressed = false)
              : this.addUndoRedoStep(this.taskDescription);
          })
          .catch(err => {
            console.log(err);
            this.showSaveIndicatorError();
            this.showAuthError = true;
            this.authMessage = err?.response?.data?.detail;
          });
      } else {
        this.showValidity = true;
      }
    },
    async patchPriority() {
      const valid = await this.$refs.viewTaskRef.validate();
      if (valid) {
        this.closeErrorIndicator();
        this.showSaveIndicator();
        this.showValidity = false;
        const data = {
          priority: this.priority ? "high" : "low"
        };
        patchTask(this.taskId, data)
          .then(() => {
            this.showSaveIndicatorSaved();
            this.$emit('priority-changed', this.queueName);
          })
          .catch(err => {
            console.log(err);
            this.showSaveIndicatorError();
            this.showAuthError = true;
            this.authMessage = err.response.data.detail;
          });
      } else {
        this.showValidity = true;
      }
    },
    async patchFrequency() {
      const valid = await this.$refs.viewTaskRef.validate();
      if (valid) {
        this.closeErrorIndicator();
        this.showSaveIndicator();
        this.showValidity = false;
        const data = {
          frequency: this.selectedFrequency
        };
        patchTask(this.taskId, data)
          .then(res => {
            this.showSaveIndicatorSaved();
            this.frequenciesList = this.frequenciesList.map(item => {
              if (
                res.data.availableFrequencyChoices.includes(item.value) ||
                item.value === res.data.frequency
              ) {
                item.disabled = false;
              } else {
                item.disabled = true;
              }
              return item;
            });
          })
          .catch(err => {
            console.log(err);
            this.showSaveIndicatorError();
            this.showAuthError = true;
            this.authMessage = err.response.data.detail;
          });
      } else {
        this.showValidity = true;
      }
    },
    async checkTask(checklist) {
      const valid = await this.$refs.viewTaskRef.validate();
      if (valid) {
        this.closeErrorIndicator();
        this.showSaveIndicator();
        this.showValidity = false;
        let title = checklist.title;
        let options = [...checklist.options];
        patchTaskChecklist(this.taskId, checklist.id, { options, title })
          .then(() => {
            this.showSaveIndicatorSaved();
          })
          .catch(err => {
            console.log(err);
            this.showSaveIndicatorError();
            this.showAuthError = true;
            this.authMessage = err.response.data.detail;
          });
      } else {
        this.showValidity = true;
      }
    },
    async patchDueDate() {
      const valid = await this.$refs.viewTaskRef.validate();
      if (valid) {
        this.showValidity = false;
        this.closeErrorIndicator();
        this.showSaveIndicator();
        const data = {
          dueDate: this.dueDate !== "" ? this.dueDate : null
        };
        patchTask(this.taskId, data)
          .then(() => {
            this.showSaveIndicatorSaved();
          })
          .catch(err => {
            console.log(err);
            this.showSaveIndicatorError();
            this.showAuthError = true;
            this.authMessage = err.response.data.detail;
          });
      } else {
        this.showValidity = true;
      }
    },
    handoverPAToClient() {
      let patchPost = false;
      this.selectedAssistant = this.assignAssistant;
      let requestID;
      if (this.currentTask.handoverRequests.length) {
        requestID = this.currentTask.handoverRequests[0].id;
        patchPost = true;
      }
      this.closeErrorIndicator();
      this.showSaveIndicator();
      const data1 = {
        action: "stop"
      };
      patchTracker(this.taskId, this.trackerID, data1)
        .then(res => {
          clearInterval(this.timer);
          this.timer = false
          this.startedAt = moment(res.data.startAt).utc();
          this.stopped = moment(res.data.stopAt).utc();
          let dura = moment.duration(this.duration, "seconds");
          let Seconds = dura._data.seconds;
          if (Seconds < 10) {
            Seconds = `0${Seconds}`;
          }
          let Minutes = dura._data.minutes;
          if (Minutes < 10) {
            Minutes = `0${Minutes}`;
          }
          let Hours = dura._data.hours + dura._data.days * 24;
          if (Hours < 10) {
            Hours = `0${Hours}`;
          }
          this.formatted = `${Hours}:${Minutes}:${Seconds}`;
          const data = {
            task: this.currentTask.id,
            requestedBy: this.profileUserId,
            assignedTo: this.assignAssistant.id,
            status: NOACTION
          };
          if (patchPost) {
            updateHandOverTask(requestID, data)
              .then(res => {
                this.showSaveIndicatorSaved();
                this.currentTask.handoverRequests.unshift(res.data);
                this.selfTask = false;
                this.savedHandover = true;
                setTimeout(() => {
                  this.savedHandover = false;
                }, 2000);
                if (this.isPopupMode) {
                  this.$emit('task-handover')
                } else {
                  this.$router.push({ name: "TaskDashboard" });
                }
              })
              .catch(err => {
                this.showSaveIndicatorError();
                this.showAuthError = true;
                this.authMessage = err.response.data.detail;
              });
          } else {
            handOverTask(data)
              .then(res => {
                this.showSaveIndicatorSaved();
                this.currentTask.handoverRequests.unshift(res.data);
                this.selfTask = false;
                this.savedHandover = true;
                setTimeout(() => {
                  this.savedHandover = false;
                }, 2000);
                if (this.isPopupMode) {
                  this.$emit('task-handover')
                } else {
                  this.$router.push({ name: "TaskDashboard" });
                }
              })
              .catch(err => {
                this.showSaveIndicatorError();
                this.showAuthError = true;
                this.authMessage = err.response.data.detail;
              });
          }
        })
        .catch(err => {
          this.showAuthError = true;
          this.authMessage = err.response.data.detail;
        });
      this.showSelectionModal = false;
    },
    customerInitial(user) {
      let fullName = `${user.firstName} ${user.lastName}`;
      return fullName.match(/\b(\w)/g).join("");
    },
    getSelectedAssistant(selected) {
      this.assignAssistant = selected;
      this.isAssign = true;
      this.isUnassign = false;
      this.showSelectionModal = true;
    },
    navigateToCustomerPreferences() {
      let routeData = this.$router.resolve({
        name: "CustomerDetails",
        params: {
          profileId: this.selectedCustomer.profileId
        },
        query: {
          tab: 1
        }
      });
      window.open(routeData.href, "_blank");
    },
    navigateToCustomerProfile() {
      let routeData = this.$router.resolve({
        name: "CustomerDetails",
        params: {
          profileId: this.selectedCustomer.profileId
        },
        query: {
          tab: 3
        }
      });
      window.open(routeData.href, "_blank");
    },
    navigateToCustomers() {
      if (
        this.$route.name === "ViewPACustomerTask" ||
        this.$route.name === "ViewPATask" || this.$route.name === "PACustomerDetails"
      ) {
        this.$router.push({
          name: "PADetails",
          params: {
            uuid: this.$route.params.uuid
          },
          query: {
            tab: 2
          }
        });
      } else if (this.$route.name === "ViewCustomerTask" || this.$route.name === "CustomerDetails") {
        if (this.role === "admin") {
          this.$router.push({ name: "CustomersListAdmin", query: { tab: 0 } });
        } else if (this.role === "assistant") {
          this.$router.push({ name: "DedicatedCustomers" });
        }
      }
    },
    navigateToCustomerDetails() {
     
      if (
        this.$route.name === "ViewPACustomerTask" ||
        this.$route.name === "ViewPATask" || this.$route.name === "PACustomerDetails"
      ) {
        this.$router.push({
          name: "PACustomerDetails",
          params: {
            profileId: this.$route.params.profileId,
            uuid: this.$route.params.uuid
          },
          query: {
            tab: 2
          }
        });
      } else if (this.$route.name === "ViewCustomerTask" || this.$route.name === "CustomerDetails") {
        this.$router.push({
          name: "CustomerDetails",
          params: {
            profileId: this.$route.params.profileId
          },
          query: {
            tab: 2
          }
        });
      }
    },
    navigateToTasks() {
      if (this.isPopupMode) {
        this.$emit('navigate')
        return
      }
      if (this.$route.name === "ViewPACustomerTask") {
        this.$router.push({
          name: "PACustomerDetails",
          params: {
            profileId: this.$route.params.profileId,
            uuid: this.$route.params.uuid
          },
          query: {
            tab: 0
          }
        });
      } else if (this.$route.name === "ViewPATask") {
        this.$router.push({
          name: "PADetails",
          params: {
            profileId: this.$route.params.profileId,
            uuid: this.$route.params.uuid
          },
          query: {
            tab: 0
          }
        });
      } else if (this.$route.name === "ViewCustomerTask") {
        this.$router.push({
          name: "CustomerDetails",
          profileId: this.$route.params.profileId,
          query: {
            tab: 0
          }
        });
      } else {
        this.$router.push({ name: "TaskDashboard" });
      }
    },
    goToPAContactInfo() {
      this.$router.push({
        name: "PADetails",
        params: {
          profileId: this.$route.params.profileId,
          uuid: this.$route.params.uuid
        },
        query: {
          tab: 1
        }
      });
    },
    fileChange(event) {
      const extensions = this.ACCEPTED_FILE_TYPES
        .split(",")
        .filter(item => item[0] === '.');

      let sizing = true;
      this.sizeExceed = false;
      for (let i = 0; i < event.target.files.length; i++) {
        if (event.target.files[i].size / 1024 / 1024 > 500) {
          sizing = false;
          break;
        }
      }
      // * empty file validation
      for (let file of event.target.files) {
        const fileExtension = `.${file.name.split(".").reverse()[0]}`
        const isRestrictedFileType = !extensions.includes(fileExtension)
        if (isRestrictedFileType) {
          this.errorModal.message = `${file.name} file format is not supported, please contact admin for more details.`;
          this.errorModal.visible = true;
          this.$refs.fileInput.value = "";
          return;
        }

        if (file.size === 0) {
          this.errorModal.message = `${file.name} is empty. Cannot upload.`;
          this.errorModal.visible = true;
          this.$refs.fileInput.value = "";
          return;
        }
      }
      if (sizing) {
        for (let i = 0; i < event.target.files.length; i++) {
          let myFile = new File(
            [event.target.files[i]],
            `${event.target.files[i].name}`
          );
          const formData = new FormData();
          formData.append("owner", this.profileUserId);
          formData.append("attachmentFile", myFile);
          this.showSaveIndicator();
          this.apiLoading = true;
          postAttachments(formData)
            .then(res => {
              let attach = res.data;
              const data = {
                task: this.taskId,
                attachment: res.data.id
              };
              postTaskAttachments(this.taskId, data)
                .then(res => {
                  res.data.attachment = attach;
                  this.attachments.push(res.data);
                  this.showSaveIndicatorSaved();
                  this.apiLoading = false;
                })
                .catch(err => {
                  console.log(err);
                  this.showAuthError = true;
                  this.authMessage = err.response.data.detail;
                  this.showSaveIndicatorError();
                  this.apiLoading = false;
                })
                .finally(() => {
                  this.$refs.fileInput.value = "";
                });
            })
            .catch(err => {
              console.log(err);
              this.showAuthError = true;
              this.authMessage = err.response.data.detail;
              this.showSaveIndicatorError();
              this.apiLoading = false;
            })
            .finally(() => {
              this.$refs.fileInput.value = "";
            });
        }
      } else {
        this.sizeExceed = true;
      }
    },
    async getSelectedStatus(selected) {
      const valid = await this.$refs.viewTaskRef.validate();
      if (!valid || selected === "null") {
        this.showValidity = true;
        return;
      }
      this.showValidity = false;
      this.closeErrorIndicator();
      this.showSaveIndicator();
      let data = {};
      this.taskStatuses.map(el => {
        if (el.slug === selected) {
          this.statusID = el.id;
        }
      });
      if (selected === "complete") {
        if (this.timer) {
          this.stopTimer();
        }
        this.completionDate = moment()
          .utc()
          .format("YYYY-MM-DD");
        data = {
          status: this.statusID,
          completedDate: this.completionDate
        };
      } else {
        if (this.stopped !== null) {
          this.restartTimer();
        }
        this.completionDate = "";
        data = {
          status: this.statusID,
          completedDate: null
        };
      }
      patchTaskBoard(this.taskId, data)
        .then(() => {
          this.showSaveIndicatorSaved();
          this.$emit('status-updated')
        })
        .catch(err => {
          this.showAuthError = true;
          this.authMessage = err.response.data.detail;
          this.showSaveIndicatorError();
        });
    },
    handleAddComment(event) {
      if (event.shiftKey) {
        this.insertNewLine(event);
      } else {
        this.addComment();
      }
    },

    addComment() {
      if (this.commentValue.trim().length === 0) {
        return;
      }
      const data = {
        comment: this.commentValue,
        task: this.taskId,
        author: this.profileUserId
      };
      this.apiLoading = true;
      postTaskComments(this.taskId, data)
        .then(response => {
          this.comments.unshift({
            ...response.data,
            avatarText: this.assistantInitials,
            isEditing: false,
          });
          this.commentValue = "";
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.apiLoading = false;
        });
    },

    insertNewLine(event) {
      event.preventDefault();
      const textarea = event.target;
      const cursorPosition = textarea.selectionStart;
      const textBeforeCursor = textarea.value.substring(0, cursorPosition);
      const textAfterCursor = textarea.value.substring(cursorPosition);

      textarea.value = `${textBeforeCursor}\n${textAfterCursor}`;
      // Adjust the cursor position to after the inserted newline character
      textarea.selectionStart = textarea.selectionEnd = cursorPosition + 1;
    },

    async removeCategory(removedOption) {
      if (this.selectedCategories.length === 1) {
        // * push back the removed option since categories is a required field
        this.selectedCategories.push(removedOption);
        this.removingLastCategory = true;
        return;
      }
      this.selectedCategories = this.selectedCategories.filter(
        el => el.id !== removedOption.id
      );
      let categories = this.selectedCategories.map(category => category.id);

      const valid = await this.$refs.viewTaskRef.validate();
      if (categories.length === 0 || !valid) {
        this.showValidity = true;
        return;
      }
      this.showValidity = false;
      const data = {
        categories: categories
      };
      this.showSaveIndicator();
      patchTask(this.taskId, data)
        .then(() => {
          this.showSaveIndicatorSaved();
        })
        .catch(err => {
          console.log(err);
          this.showSaveIndicatorError();
          this.showAuthError = true;
          this.authMessage = err.response.data.detail;
        });
      this.attachments.map(attachment => {
        if (attachment.copiedFrom === removedOption.id) {
          deleteTaskCategoryAttachment(this.taskId, attachment.id)
            .then(() => {
              this.attachments = this.attachments.filter(
                item => item.copiedFrom !== removedOption.id
              );
            })
            .catch(err => {
              console.log(err);
            });
        }
      });

      this.checklists.map(checklist => {
        if (checklist.copiedFrom === removedOption.id) {
          deleteTaskCategoryChecklist(this.taskId, checklist.id)
            .then(() => {
              this.checklists = this.checklists.filter(
                item => item.id !== checklist.id
              );
            })
            .catch(err => {
              console.log(err);
            });
        }
      });

      this.preferences = this.preferences.filter(
        preference => preference.categories.category.id !== removedOption.id
      );
    },
    showDeleteChecklistModal(checklistIndex) {
      this.deleteModal.checklistIndex = checklistIndex;
      this.deleteModal.visible = true;
    },
    deleteChecklist(index) {
      let { checklists } = this;
      let checklist = checklists[index];
      this.showSaveIndicator();
      this.apiLoading = true;
      deleteTaskCategoryChecklist(this.taskId, checklist.id)
        .then(() => {
          this.$delete(this.checklists, index);
          this.showSaveIndicatorSaved();
        })
        .catch(err => {
          console.log(err);
          this.showSaveIndicatorError();
        })
        .finally(() => {
          this.apiLoading = false;
          this.deleteModal.visible = false;
        });
    },
    removeOption(checklist, index) {
      this.showSaveIndicator();
      this.apiLoading = true;
      const data = [{ id: this.checklists[checklist].options[index].id }];
      deleteTaskCategoryChecklistOptions(
        this.taskId,
        this.checklists[checklist].id,
        data
      )
        .then(() => {
          this.checklists[checklist].options.splice(index, 1);
          this.showSaveIndicatorSaved();
        })
        .catch(() => {
          this.showSaveIndicatorError();
        })
        .finally(() => {
          this.apiLoading = false;
        });
    },
    saveChecklistOption(
      newChecklistOption,
      checklistIndex,
      optionIndex,
      isNewOption
    ) {
      let checklist = this.checklists[checklistIndex];
      this.$set(checklist, "showNewOptionBox", true);
      if (isNewOption) {
        if (newChecklistOption.length > 0) {
          checklist.options.push({
            deletedAt: null,
            description: "",
            isChecked: false,
            copiedFrom: checklist.category ? checklist.category : null,
            title: newChecklistOption
          });
          newChecklistOption = "";
        } else {
          return;
        }
      } else {
        let option = checklist.options[optionIndex];
        if (option.title.length > 0) {
          this.$set(option, "isEditing", false);
        } else {
          // * if the option title is empty, then it is equal to removing the option
          // * so we call removeOption()
          this.removeOption(checklist, optionIndex);
          return;
        }
      }
      this.apiLoading = true;
      this.showSaveIndicator();
      let checkListLength = checklist?.options && checklist.options.length;
      let checkListTitle = checklist?.options[checkListLength - 1]?.title;
      if (isNewOption && checkListTitle?.length) {
        let data = {
          title: checkListTitle
        };
        postTaskChecklistOption(this.taskId, checklist.id, data)
          .then(res => {
            res.data;
            this.showSaveIndicatorSaved();
          })
          .catch(err => {
            console.log(err);
            this.showSaveIndicatorError();
          })
          .finally(() => {
            this.apiLoading = false;
          });
      } else {
        patchTaskChecklist(this.taskId, checklist.id, checklist)
          .then(res => {
            let checklist = res.data;
            checklist.options.sort(optionsSortFn);
            this.$set(this.checklists, checklistIndex, res.data);
            this.showSaveIndicatorSaved();
          })
          .catch(err => {
            console.log(err);
            this.showSaveIndicatorError();
          })
          .finally(() => {
            this.apiLoading = false;
          });
      }
    },
    createChecklist() {
      if (this.checklistValue.length === 0) {
        return;
      }
      let data = {
        title: this.checklistValue,
        options: [],
        isCopied: false,
        copiedFrom: null,
        task: this.taskId
      };
      this.showSaveIndicator();
      postTaskChecklist(this.taskId, data)
        .then(res => {
          this.checklists.push({
            ...res.data
          });
          this.showSaveIndicatorSaved();
        })
        .catch(err => {
          console.log(err);
          this.showSaveIndicatorError();
        })
        .finally(() => {});
      this.checklistValue = "";
    },
    deleteAttachment(attachmentParam) {
      let attachment = attachmentParam[0];
      let attachmentIndex = attachmentParam[1];
      this.showSaveIndicator();
      this.apiLoading = true;
      return deleteTaskCategoryAttachment(this.taskId, attachment.id)
        .then(() => {
          this.attachments.splice(attachmentIndex, 1);
          this.showSaveIndicatorSaved();
        })
        .catch(err => {
          console.log(err);
          this.showSaveIndicatorError();
        })
        .finally(() => {
          this.apiLoading = false;
        });
    },
    deleteTask() {
      this.pageLoading2 = true;
      deleteTask(this.taskId)
        .then(() => {
          this.pageLoading2 = false;
          if (this.isPopupMode) {
            this.$emit('task-deleted')
          } else {
            this.$router.go(-1);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    archiveTask() {
      this.pageLoading_archive = true;
      let data = {
        isArchive: true
      };
      archiveTask(this.taskId, data)
        .then(() => {
          this.pageLoading_archive = false;
          if (this.isPopupMode) {
            this.$emit("task-archived");
          } else {
            this.$router.go(-1);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    async patchTask() {
      this.errorMessage = false;
      this.totalApiCalls.length = 0;
      this.passedApiCalls.length = 0;
      this.successMessage = false;
      this.showValidity = false;
      const valid = await this.$refs.viewTaskRef.validate();
      if (valid) {
        this.showValidity = false;
        this.pageLoading = true;
        let categories = [];
        for (let i = 0; i < this.selectedCategories.length; i++) {
          categories.push(this.selectedCategories[i].id);
        }
        this.taskStatuses.map(el => {
          if (el.slug === this.selectedStatus) {
            this.statusID = el.id;
          }
        });
        const data = {
          title: this.taskTitle,
          description: this.taskDescription,
          status: this.statusID,
          createdFor: this.customerID,
          categories: categories,
          dueDate: this.dueDate !== "" ? this.dueDate : null,
          completedDate:
            this.completionDate.length > 0 ? this.completionDate : null,
          assignedTo: this.assistantId,
          frequency: this.selectedFrequency,
          priority: this.priority ? "high" : "low"
        };
        patchTask(this.taskId, data)
          .then(() => {
            for (let i = 0; i < this.attachments.length; i++) {
              if (this.attachments[i].name) {
                let myFile = new File(
                  [this.attachments[i]],
                  `${this.attachments[i].name}`
                );
                const formData = new FormData();
                formData.append("owner", this.profileUserId);
                formData.append("attachmentFile", myFile);
                postAttachments(formData)
                  .then(res => {
                    const data = {
                      task: this.taskId,
                      attachment: res.data.id
                    };
                    postTaskAttachments(this.taskId, data)
                      .then(() => {})
                      .catch(err => {
                        console.log(err);
                      })
                      .finally(() => {});
                  })
                  .catch(err => {
                    console.log(err);
                  });
              } else if (this.attachments[i].category) {
                const data = {
                  task: this.taskId,
                  attachment: this.attachments[i].attachment?.id,
                  copiedFrom: this.attachments[i].category
                    ? this.attachments[i].category
                    : null,
                  isCopied: this.attachments[i].id ? true : false
                };
                postTaskAttachments(this.taskId, data)
                  .then(() => {})
                  .catch(err => console.log(err))
                  .finally(() => {});
              }
            }
            for (let i = 0; i < this.checklists.length; i++) {
              if (
                (this.checklists[i].id && this.checklists[i].isCopied) ||
                (this.checklists[i].id && this.checklists[i].isCustomChecklist)
              ) {
                patchTaskChecklist(
                  this.taskId,
                  this.checklists[i].id,
                  this.checklists[i]
                )
                  .then(() => {})
                  .catch(err => {
                    console.log(err);
                  });
              } else {
                const data = {
                  title: this.checklists[i].title,
                  task: this.taskId,
                  isCopied:
                    this.checklists[i].id &&
                    !this.checklists[i].isCustomChecklist
                      ? true
                      : false,
                  copiedFrom: this.checklists[i].category
                    ? this.checklists[i].category
                    : null,
                  options: [...this.checklists[i].options]
                };
                postTaskChecklist(this.taskId, data)
                  .then(() => {})
                  .catch(err => {
                    console.log(err);
                  })
                  .finally(() => {});
              }
            }
            this.$router.go(-1);
          })
          .catch(err => {
            console.log(err);
            this.showAuthError = true;
            this.authMessage = err.response.data.detail;
          })
          .finally(() => {
            this.pageLoading = false;
          });
        this.removedAttachments.map(item => {
          if (item.isCopied) {
            deleteTaskCategoryAttachment(this.taskId, item.id);
          }
        });
        this.removedChecklists.map(item => {
          if (item.isCopied) {
            deleteTaskCategoryChecklist(this.taskId, item.id);
          }
        });
        this.removedOptions.map(item => {
          if (item.option.id) {
            const data = [{ id: item.option.id }];
            deleteTaskCategoryChecklistOptions(
              this.taskId,
              item.checklistID,
              data
            )
              .then(() => {})
              .catch(err => {
                console.log(err);
              });
          }
        });
      } else {
        this.showValidity = true;
      }
    },
    async getSelectedCategories(selected) {
      let categories = [];
      for (let i = 0; i < this.selectedCategories.length; i++) {
        categories.push(this.selectedCategories[i].id);
      }
      categories.push(selected.id);
      // * need to wait for the reactive prop selectedCategories to get updated
      // * else the ValidationObserver doesn't take the most recent value of it
      await new Promise(resolve => {
        setTimeout(() => {
          resolve(true);
        }, 100);
      });
      const valid = await this.$refs.viewTaskRef.validate();
      if (!valid) {
        this.showValidity = true;
        return;
      }
      this.showValidity = false;
      const data = {
        categories: categories
      };
      this.closeErrorIndicator();
      this.showSaveIndicator();

      // * flag to check if preference has the checklist or need to load from category
      let getChecklistFromCategory = false;

      try {
        await patchTask(this.taskId, data);
        this.showSaveIndicatorSaved();
      } catch (err) {
        this.showSaveIndicatorError();
        this.showAuthError = true;
        this.authMessage = err.response.data.detail;
      }

      try {
        if (this.customerID !== "") {
          // * holding execution untill we get the checklist from preferences, if any
          let res = await getCategoryPreferences(this.customerID, selected.id);
          this.preferences = [...this.preferences, ...res.data.results];
          if (res.data.results[0]?.categories?.preferencesChecklist?.length) {
            let newChecklists = res.data.results[0].categories.preferencesChecklist;
            newChecklists.forEach(checklist => {
              checklist.category = selected.id;
            });
            this.saveChecklists(newChecklists);
          } else {
            getChecklistFromCategory = true;
          }
        }
      } catch (err) {
        this.showAuthError = true;
        this.authMessage = err.response.data.detail;
      }
      // * getting checklists and attachments data from category after checking preferences
      getCategory(selected.id)
        .then(res => {
          this.saveAttachments(res.data.attachments);

          // * will get checklist from category only if preferences don't have any checklist for the category
          getChecklistFromCategory && this.saveChecklists(res.data.checklists);
        })
        .catch(err => {
          console.log(err);
        });
    },
    saveChecklistTitle(index, newChecklistTitle) {
      let checklist = this.checklists[index];
      if (newChecklistTitle.length > 0) {
        checklist.title = newChecklistTitle;
        this.checkTask(this.checklists[index]);
      }
    },
    closePreferencesSidebar() {
      this.preferencesSidebar.visible = false;
    },
    openPreferencesSidebar() {
      this.preferencesSidebar.visible = true;
    },
    startTimer() {
      if (window.Worker) {
        const worker = new Worker()
        this.worker = worker
        worker.postMessage({ 
          currentTime: this.duration,
          action: 'start'
        })
        this.timer = true
        worker.addEventListener("message", event => {
          let { currentTime } = event.data
          this.duration = currentTime
          this.formatted = this.getFormattedDuration()
        })
      } else {
        this.timer = setInterval(() => {
        this.duration += 1;
        this.formatted = this.getFormattedDuration()
        }, 1000);
      }
    },
    getFormattedDuration() {
      let dura = moment.duration(this.duration, "seconds");
      let Seconds = dura._data.seconds;
      if (Seconds < 10) {
        Seconds = `0${Seconds}`;
      }
      let Minutes = dura._data.minutes;
      if (Minutes < 10) {
        Minutes = `0${Minutes}`;
      }
      let Hours = dura._data.hours + dura._data.days * 24;
      if (Hours < 10) {
        Hours = `0${Hours}`;
      }
      return `${Hours}:${Minutes}:${Seconds}`;
    },
    restartTimer() {
      this.timerLoading = true;
      this.createdAt = moment()
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss.SSSSSS[Z]");
      const timerData = {
        creator: this.profileUserId,
        task: this.taskId,
        action: "start",
        startAt: this.createdAt
      };
      postTracker(this.taskId, timerData)
        .then(res => {
          this.completionDate = "";
          this.trackerID = res.data.id;
          getTask(this.taskId)
            .then(res => {
              this.currentTask = res.data;
              this.startedAt = moment(res.data.lastTracker.startAt);
              this.stopped =
                res.data.lastTracker.stopAt === null
                  ? null
                  : moment(res.data.lastTracker.stopAt);
              this.duration = moment()
                .utc()
                .diff(res.data.lastTracker.startAt, "seconds");
              this.duration += res.data.trackersLog.timeSpent;
              this.startTimer();
              this.$emit('timer-started')
            })
            .catch(err => {
              this.showAuthError = true;
              this.authMessage = err.response.data.detail;
            })
            .finally(() => {
              this.timerLoading = false;
            });
        })
        .catch(err => {
          this.showAuthError = true;
          this.authMessage = err.response.data.detail;
          this.timerLoading = false;
        });
    },
    stopTimer() {
      const data = {
        action: "stop"
      };
      this.timerLoading = true;
      patchTracker(this.taskId, this.trackerID, data)
        .then(res => {
          if (window.Worker) {
            if (this.worker) {
              this.worker.terminate()
              this.timer = false
            }
          } else {
            clearInterval(this.timer);
          }
          this.timer = false
          this.startedAt = moment(res.data.startAt).utc();
          this.stopped = moment(res.data.stopAt).utc();
          let dura = moment.duration(this.duration, "seconds");
          let Seconds = dura._data.seconds;
          if (Seconds < 10) {
            Seconds = `0${Seconds}`;
          }
          let Minutes = dura._data.minutes;
          if (Minutes < 10) {
            Minutes = `0${Minutes}`;
          }
          let Hours = dura._data.hours + dura._data.days * 24;
          if (Hours < 10) {
            Hours = `0${Hours}`;
          }
          this.formatted = `${Hours}:${Minutes}:${Seconds}`;
          this.$emit('timer-stopped')
        })
        .catch(err => {
          this.showAuthError = true;
          this.authMessage = err.response.data.detail;
        })
        .finally(() => {
          this.timerLoading = false;
        });
    },
    reloadPage() {
      this.showAuthError = false;
      this.$router.go();
    },
    saveAttachments(attachmentArr) {
      attachmentArr.map(item => {
        const data = {
          task: this.taskId,
          attachment: item.attachment.id,
          copiedFrom: item.category,
          isCopied: true
        };
        postTaskAttachments(this.taskId, data)
          .then(res => {
            this.attachments.push(res.data);
          })
          .catch(err => console.log(err))
          .finally(() => {});
      });
    },
    saveChecklists(checklist) {
      checklist.map(item => {
        const data = {
          title: item.title,
          task: this.taskId,
          isCopied: true,
          copiedFrom: item.category,
          options: [...item.options]
        };
        postTaskChecklist(this.taskId, data)
          .then(res => {
            let newCheckList = this.sortChecklistByPosition(res.data);
            this.checklists.push(newCheckList);
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {});
      });
    },
    checkApis() {
      if (
        this.totalApiCalls.length ===
        1 + this.attachments.length + this.checklists.length
      ) {
        this.pageLoading = false;
        if (this.passedApiCalls.length === this.totalApiCalls.length) {
          this.success = true;
          this.successMessage = true;
          this.$router.go(-1);
        } else {
          this.errorMessage = true;
        }
      }
    },
    onThumbnailClick(attachment, attachmentIndex) {
      if (this.isImage(attachment)) {
        this.previewModal.attachment = attachment;
        this.previewModal.attachmentIndex = attachmentIndex;
        this.previewModal.visible = true;
      }
    },
    async onDeleteImage(index) {
      try {
        await this.deleteAttachment([this.attachments[index], index]);
      } catch (e) {
        console.log(e);
      }
    },
    showSaveIndicator() {
      this.indicatorsVisible.error = false;
      this.indicatorsVisible.saved = false;
      this.indicatorsVisible.saving = true;
    },
    showSaveIndicatorSaved() {
      this.indicatorsVisible.error = false;
      this.indicatorsVisible.saving = false;
      this.indicatorsVisible.saved = true;
      window.setTimeout(() => {
        this.indicatorsVisible.saved = false;
      }, 1500);
    },
    showSaveIndicatorError() {
      this.indicatorsVisible.saving = false;
      this.indicatorsVisible.saved = false;
      this.indicatorsVisible.error = true;
    },
    closeErrorIndicator() {
      this.indicatorsVisible.error = false;
    },
    async updateChecklistItemPositions(checklist) {
      this.showSaveIndicator();
      try {
        await updateChecklistItemPositionsAsync.call(this, checklist);
        this.showSaveIndicatorSaved();
      } catch (e) {
        console.log(e);
        this.showSaveIndicatorError();
      }
    },
    async handleSaveComment(callback, ...args) {
      const event = args.pop();
      if (event.shiftKey) {
        this.insertNewLine(event);
      } else {
        await callback(...args);
      }
    },
    async saveComment(comment, index) {
      comment.isEditing = false
      if (comment.comment.trim().length === 0) {
        comment.comment = this.originalComment
        return;
      }
      const data = {
        comment: comment.comment,
      };
      this.apiLoading = true;
      try {
        this.showSaveIndicator()
        await patchComment(this.taskId, comment.id, data)
        this.comments[index].modified = new Date().toISOString()
        this.showSaveIndicatorSaved()
      } catch(e) {
        this.showSaveIndicatorError()
      } finally {
        this.apiLoading = false
      }
    },
    getCommentTimestamp(comment) {
      let { created, modified } = comment
      const _created = moment(created)
      const _modified = moment(modified)
      const isJustCreated = _modified.diff(_created, "seconds") < 1

      if (isJustCreated) {
        return `Created ${_created.calendar()}`
      } else {
        return `Edited ${_modified.calendar()}`
      }
    },
    async _deleteComment() {
      this.deleteCommentModal.loading = true
      try {
        this.showSaveIndicator()
        await deleteComment(this.taskId, this.deleteCommentModal.commentId)
        this.comments = this.comments.filter(comment => comment.id !== this.deleteCommentModal.commentId)
        this.showSaveIndicatorSaved()
        this.deleteCommentModal.visible = false
      } catch (e) {
        console.log(e)
        this.showSaveIndicatorError()
      } finally {
        this.deleteCommentModal.loading = false
      }
    },
    deleteComment(comment) {
      this.deleteCommentModal.commentId = comment.id
      this.deleteCommentModal.loading = false
      this.deleteCommentModal.visible = true
    },
    canDeleteComment(comment) {
      let loggedInUserId = this.$store.state.authModule.profileUserId
      // * a user can edit only their own comments
      if (loggedInUserId !== comment.author.id) {
        return false
      }
      if (comment.isSystemGenerated) {
        return false
      }
      return true
    },
    onCommentClick(comment) {
      let loggedInUserId = this.$store.state.authModule.profileUserId
      // * a user can edit only their own comments
      if (loggedInUserId !== comment.author.id || comment.isSystemGenerated) {
        return
      }
      this.comments.forEach(comment => comment.isEditing = false)
      this.originalComment = comment.comment
      comment.isEditing = true
    },
    getModalAvatarUser() {
      let { assignAssistant } = this
      if (assignAssistant.user) {
        return assignAssistant.user
      }
      let retValue = {
        ...assignAssistant,
        avatarThumbnail: assignAssistant.avatar
      }
      return retValue
    },
    onChecklistItemDrop,
    onDragStart,
    onDragEnd,

    async getTaskNameSuggestion() {
      let res = await getTaskSuggestionList();
      this.taskSuggestions = res.data.results.map(task => {
        return { value: task.title, text: task.title };
      });
    },
    patchChecklist(data) {
      this.showSaveIndicator();
      patchTaskChecklist(this.taskId, data.id, {
        options: data.options
      })
        .then(() => {
          this.showSaveIndicatorSaved();
        })
        .catch(e => {
          console.log(e);
          this.showSaveIndicatorError();
        });
    },
  }
};
</script>

<style scoped lang="scss">
@import "~@/scss/variables/colors.scss";
@import "~@/scss/common/fonts.scss";

::v-deep .delete-comment-modal-body {
  font-size: $font-size-md;
  padding: 10px;
  > div {
    padding: 10px;
    line-height: normal;
  }
  > .desc-row {
    color: $primary;
    opacity: 0.5;
  }
  > .button-row {
    display: flex;
    button {
      padding: 8px 15px;
    }
    .cancel-button {
      margin-right: 10px;
      background: white;
      color: $primary-dark;
      border: 1px solid $primary-dark;
    }
  }
  .close-button {
    right: -28px;
    position: absolute;
    display: flex;
    top: -22px;
    background: transparent !important;
  }
}

.comment-spacing {
  top: 0.8rem;
  word-break: break-word;
}
.breadcrumb-container-left {
  left: 0;
}
.customer-details {
  right: 2%;
  overflow-wrap: break-word;
}
.sidebar-preferences-wrapper {
  margin-bottom: 10rem;
}
.add-attachment-top {
  top: 0.8rem;
}
.tasks-attachment-card {
  width: inherit;
  height: 4rem;
  padding-left: 1.2rem;
  padding-right: 1.2rem;
  border: 1px solid $form-item-border;
}
.comment-card-body {
  width: 30rem;
}
.high-priority-text {
  line-height: 1.8rem;
}
.preferences-heading {
  font-weight: bold;
  padding: 10px 0px;
  color: $primary--text;
  font-size: 1.4rem !important;
}
.tasks-form-card {
  height: 4rem;
}
.tasks-vertical-divider {
  border-left: 1px solid $primary-lighter;
  top: 3rem;
}
.add-comment-input-box {
  height: 4rem;
  min-height: 4.4rem;
}
.remove-option-icon {
  right: 0.5rem;
}
.start-timer-btn {
  padding: 1rem 2rem !important;
}
.start-timer-btn p,
.timer-pause-container p,
.timer-running-container p {
  top: 0.5rem;
}
.attachment-delete-btn,
.checklist-delete-btn {
}
.checkbox-title-container {
  z-index: 0;
}
.checklist-option-input-wrapper {
  flex: 1;
}
.attachment-text {
  font-size: 1.5rem !important;
  word-wrap: break-word;
}

.show-timer p {
  top: 1.2rem;
}

.checklist-options-container {
  margin-bottom: 0.5rem;
}

.tasks-dropdown-divider {
  margin-top: 1.2rem;
}
.btn-delete {
  background: var(--td-btn-primary, #8f00ff);
  border-color: var(--td-btn-primary, #8f00ff);
  color: white;
}
.tasks-right-container {
  position: fixed;
  right: 0;
  z-index: 2;
  display: flex;
  padding: 0;
  top: 9rem;
  background: #fff;
  height: 100vh;
  overflow-y: auto;
}
.input-icon-container {
  right: 1rem;
  top: 1.2rem;
}
.box-container {
  height: 10rem;
  width: 15rem;
  border-radius: 6px;
  width: 15rem;
}
.heading-wrapper {
  display: flex;
}
.content-title {
  margin-bottom: 0px;
}
.show-timer-container {
  margin-left: auto;
}

.box-container a {
  opacity: 0.3;
}
.carousel-outer-container p {
  margin-top: 1rem;
}
.tasks-preferences {
  z-index: 100000;
  width: inherit;
}
.timer-resume {
  right: -1.5px;
  cursor: pointer;
}
button.btn.close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none;
}
.saved-text {
  color: #70e267;
}
.info-wrapper {
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  > .avatar-wrapper {
    padding-right: 15px;
  }
  > .other-wrapper {
    flex: 2;
    display: flex;
    flex-direction: column;
    div,
    p {
      display: flex;
      align-items: center;
    }
  }
  p {
    margin: 0;
  }
}
.box-container.thumbnail-wrapper {
  > img {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}
.form-disabled {
  background-color: $background-disabled;
}
</style>
<style lang="scss">
@import "~@/scss/variables/colors.scss";
$image-dimension: 25px;
$pink: #f35a63;
$dark-blue: #0a374b;

/* Custom CSS to increase font-weight of bold text in Quill editor */
.quill-custom .ql-editor strong {
  text-shadow: 1px 0 $primary;
  letter-spacing: 1px;
}

#save-indicator,
#save-error-indicator {
  border-radius: 999px;
  margin: auto;
  box-shadow: none;
  border: none;
  width: fit-content;
  div.toast-body {
    padding: 10px 5px;
    font-size: 16px;
    display: flex;
  }
}
#save-indicator:focus,
#save-error-indicator:focus {
  border: none;
  outline: none;
}

#save-indicator {
  width: 113px;
  div.toast-body {
    background: $dark-blue;
    border-radius: 999px;
    color: white;
    display: flex;
  }
  #loading-icon-wrapper {
    > img {
      height: $image-dimension;
      width: $image-dimension;
      animation: spin 1s linear infinite;
    }
  }
  #saved-icon-wrapper {
    > img {
      height: $image-dimension;
      width: $image-dimension;
      animation: growIn 1s;
    }
  }
  #save-indicator-text {
    flex: 2;
    text-align: center;
  }
}
#save-error-indicator {
  width: 300px;
  display: flex;
  border-radius: 999px;
  background: #f35a63;
  display: flex;
  > div.toast-body {
    flex: 1;
  }
  #save-indicator-text-error {
    color: white;
  }
  #error-icon-wrapper {
    background: #f35a63;
    border-bottom-left-radius: 999px;
    border-top-left-radius: 999px;
    color: white;
    flex: 1;
    > img {
      height: $image-dimension;
      width: $image-dimension;
    }
  }
  #save-indicator-text {
    color: white;
    background: #f35a63;
    flex: 8;
    text-align: center;
  }
  #save-indicator-close-icon {
    background: #f35a63;
    color: white;
    width: $image-dimension;
    height: $image-dimension;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    > img {
      cursor: pointer;
      flex: 1;
      height: $image-dimension;
      width: $image-dimension;
    }
    border-bottom-right-radius: 999px;
    border-top-right-radius: 999px;
  }
}
.checklist-title-input {
  width: 80%;
  z-index: 5;
}
.checklist-title {
  z-index: 2;
  cursor: pointer;
}
.delete-button-row {
  padding-left: 30px;
  button {
    margin-left: 15px;
  }
}
.spinner-wrapper {
  margin-left: auto;
  padding-right: 1.5rem;
  display: flex;
}
.comments-container {
  .card-body, h6 {
    padding: 8px;
  }
  h6 {
    margin-bottom: 0;
    line-height: normal;
  }
}
.comment {
  padding: 8px;
  display: flex;
  .comment-card-wrapper {
    display: flex;
    flex-direction: column;
    flex: 1;
    .card-body {
      cursor: pointer;
    }
    .comment-delete-icon-wrapper {
      margin-left: auto;
      display: flex;
      align-items: center;
      padding-left: 4px;
    }
  }
  .form-input-wrapper {
    flex: 1;
  }
  .b-avatar {
    margin-right: 16px;
  }
}
.comment-time {
  margin-top: 4px;
}
#right-column .custom-select {
  border-radius: 2rem;
}
.delete-popup-title,
.archive-popup-title {
  font-size: 1.8rem;
}
.modal-delete-container,
.modal-archive-container {
  padding: 1rem 3rem;
}
.checklist-options-container .smooth-dnd-draggable-wrapper {
  margin-bottom: 1rem;
}
.checklist-option-container p {
  line-height: 3rem;
}
.modal-content {
  margin: auto;
}
.view-task-modal > .modal-content {
  width: 100%;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes growIn {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}
@media screen and (max-width: 991px) {
  .add-task-container {
    left: 0;
    width: 100%;
  }
  .add-task-container,
  .view-task-container {
    top: 18rem;
  }
}
@media screen and (max-width: 599px) {
  .add-task-container {
    height: 100vh;
  }
}
.tox-notifications-container {
  display: none;
}
.tox-toolbar {
  background: none !important;
  border-bottom: 1px solid $primary-lighter !important;
}
.tox-statusbar {
  display: none !important;
}
.tox-tinymce {
  border: 1px solid $primary-lighter !important;
  border-radius: 2.5px !important;
}
</style>
